var configureglobals = new PageGlobals();
var JAVA_INTEGER_MAX_VALUE = 2147483647;

function StockModel () {

}

StockModel.prototype = {

    initialize: function (productConfigData) {
        this.productConfigData = this.keepOfferedVariants(productConfigData);

        this.initializeVariantChoices();
        this.initializeQuantity();
        this.initializeUnitStockPriceAndWeightOverrideAmounts();
        this.initializeAdditionalFields();
    },

    // TTI-20903: a site share may sell only some of the master's variants; the page leaves the others out.
    keepOfferedVariants: function (productConfigData) {
        var offered = stockGlobals.offeredVariantIds;
        if (productConfigData && productConfigData.variants && Array.isArray(offered)) {
            productConfigData.variants = productConfigData.variants.filter(function (variant) {
                return offered.indexOf(variant.id) >= 0;
            });
        }
        return productConfigData;
    },

    initializeUnitStockPriceAndWeightOverrideAmounts: function () {
        this.unitStockPriceOverrideAmount = null;
        this.unitWeightLbsOverrideAmount = null;
        if (USER_TYPE === 'SUPPLIER_ADMIN') {
            // for custom quotes, initialize unitStockPriceOverrideAmount and unitWeightLbsOverrideAmount to the default price if they are not set in orderItem
            this.applyDefaultPriceAndWeight = true;
        }
    },

    initializeAdditionalFields: function () {
        this.additionalFields = {};
        var metadata = this.productConfigData.metadata;
        if (metadata) {
            for (var i = 0; i < metadata.length; i++) {
                var metadataItem = metadata[i];
                if (metadataItem.dataType === 'CB') {
                    this.additionalFields[metadataItem.name] = 'false';
                } else {
                    this.additionalFields[metadataItem.name] = '';
                }
            }
        }

        // The offering metadata is available for an existing order item.
        // Since requoting is not available for stock products on the storefront,
        // this initialization is required only for custom quotes.
        if (USER_TYPE === 'SUPPLIER_ADMIN' && this.productConfigData.overrides && this.productConfigData.overrides.offeringMetadata) {
            var overridesAdditionalFields = this.productConfigData.overrides.offeringMetadata;
            for (var propName in overridesAdditionalFields) {
                var field = overridesAdditionalFields[propName];
                this.additionalFields[field.QUESTION] = field.ANSWER;
            }
        }
    },

    isQuoteModePrivileged: function () {
        return configuratorGlobals.isQuoteModePrivileged;
    },

    initializeQuantity: function () {
        this.qty = (USER_TYPE === 'SUPPLIER_ADMIN' && this.productConfigData.overrides && this.productConfigData.overrides.quantity)
            || this.productConfigData.defaults.quantity
            || 1;
    },

    initializeVariantChoices: function () {
        var variant1Choices = this.getVariantChoices(1);
        var variant2Choices = this.getVariantChoices(2);
        var variant3Choices = this.getVariantChoices(3);

        // Initialize from overrides.variantId if present, used for custom quotes
        if (USER_TYPE === 'SUPPLIER_ADMIN' && this.productConfigData.overrides && this.productConfigData.overrides.variantId) {
            var selectedVariant = this.productConfigData.variants.find(function (v) {
                return v.id === this.productConfigData.overrides.variantId;
            }.bind(this));

            if (selectedVariant) {
                if (selectedVariant.attribute1Choice && variant1Choices) {
                    var choice1 = variant1Choices.find(function (c) {
                        return c.name === selectedVariant.attribute1Choice;
                    });
                    if (choice1) {
                        this.variant1Choice = choice1;
                    }
                }
                if (selectedVariant.attribute2Choice && variant2Choices) {
                    var choice2 = variant2Choices.find(function (c) {
                        return c.name === selectedVariant.attribute2Choice;
                    });
                    if (choice2) {
                        this.variant2Choice = choice2;
                    }
                }
                if (selectedVariant.attribute3Choice && variant3Choices) {
                    var choice3 = variant3Choices.find(function (c) {
                        return c.name === selectedVariant.attribute3Choice;
                    });
                    if (choice3) {
                        this.variant3Choice = choice3;
                    }
                }
                return;
            }
        }

        // Default initialization
        if (variant1Choices) {
            this.variant1Choice = variant1Choices[0];
        }

        if (variant2Choices) {
            this.variant2Choice = variant2Choices[0];
        }

        if (variant3Choices) {
            this.variant3Choice = variant3Choices[0];
        }
        this.keepSoldChoices();
    },

    getSelectedVariantId: function () {
        if (!this.productConfigData || !this.productConfigData.variants) {
            return null;
        }

        var selectedVariants = this.getSelectedVariants();
        var attribute1Choice = selectedVariants[1];
        var attribute2Choice = selectedVariants[2];
        var attribute3Choice = selectedVariants[3];

        var matchedVariant = this.productConfigData.variants.find(function (variant) {
            var matches = true;

            if (attribute1Choice !== undefined && attribute1Choice !== null) {
                matches = matches && variant.attribute1Choice === attribute1Choice;
            }

            if (attribute2Choice !== undefined && attribute2Choice !== null) {
                matches = matches && variant.attribute2Choice === attribute2Choice;
            }

            if (attribute3Choice !== undefined && attribute3Choice !== null) {
                matches = matches && variant.attribute3Choice === attribute3Choice;
            }

            return matches;
        });

        return matchedVariant ? matchedVariant.id : null;
    },

    getVariantTitleCount: function () {
        return this.getStockAttributeTitleCount(this.productConfigData.systemOffering
            ? this.productConfigData.systemOffering
            : this.productConfigData);
    },

    getStockAttributeTitleCount: function (offering) {
        var i = 0;
        if (hasValue(offering.stockAttributeTitle1)) {
            i += 1;
        }
        if (hasValue(offering.stockAttributeTitle2)) {
            i += 1;
        }
        if (hasValue(offering.stockAttributeTitle3)) {
            i += 1;
        }
        return i;
    },

    setVariant: function (variantNum, newValue) {
        var variant = this.productConfigData.variants.find(function (v) {
            return v.id === +newValue;
        });
        this['variant' + variantNum + 'Choice'] = variant ? {
            id: variant.id,
            name: variant['attribute' + variantNum + 'Choice']
        } : null;
    },

    setUnitStockPriceOverrideAmount: function (newValue) {
        if (!newValue || +newValue === 0) {
            this.unitStockPriceOverrideAmount = null;
        } else {
            this.unitStockPriceOverrideAmount = +newValue;
        }
        this.applyDefaultPriceAndWeight = false;
    },

    setUnitWeightLbsOverrideAmount: function (newValue) {
        if (!newValue || +newValue === 0) {
            this.unitWeightLbsOverrideAmount = null;
        } else {
            this.unitWeightLbsOverrideAmount = +newValue;
        }
        this.applyDefaultPriceAndWeight = false;
    },

    getAvailableInventory: function (variant) {
        return variant.actualInventory - variant.reservedInventory - variant.backorderInventory;
    },

    getStockAttributeTitle: function (num) {
        var offering = this.productConfigData.systemOffering ? this.productConfigData.systemOffering : this.productConfigData;
        return offering['stockAttributeTitle' + num];
    },

    getVariantChoices: function (variantNum) {
        var valueProp = 'attribute' + variantNum + 'Choice';
        var choices = [];

        for (var i = 0; i < this.productConfigData.variants.length; i++) {
            var variant = this.productConfigData.variants[i];

            if (!variant.enabled) {
                continue;
            }

            var name = variant[valueProp];

            var choiceInList = choices.some(function (choice) {
                return choice.name === name;
            });

            if (name && !choiceInList) {
                choices.push({ id: variant.id, name: name });
            }
        }

        return choices;
    },

    // TTI-20903: a share may sell a size in some colors only. A later attribute's choice is sold when an enabled variant
    // has it with every earlier choice made.
    isChoiceSold: function (variantNum, name) {
        return this.getVariants().some(function (variant) {
            if (!variant.enabled || variant['attribute' + variantNum + 'Choice'] !== name) {
                return false;
            }
            for (var n = 1; n < variantNum; n++) {
                var earlier = this['variant' + n + 'Choice'];
                if (earlier && earlier.name != null && variant['attribute' + n + 'Choice'] !== earlier.name) {
                    return false;
                }
            }
            return true;
        }, this);
    },

    // "Not available in Red", naming the earlier choices that leave it unsold.
    unsoldChoiceNote: function (variantNum) {
        var earlier = [];
        for (var n = 1; n < variantNum; n++) {
            var choice = this['variant' + n + 'Choice'];
            if (choice && choice.name) {
                earlier.push(choice.name);
            }
        }
        return 'Not available in ' + earlier.join(' / ');
    },

    // Moves a later attribute off a choice the earlier ones leave unsold, onto the first that is sold, so the page never
    // quotes a variant the share does not sell.
    keepSoldChoices: function () {
        for (var n = 2; n <= 3; n++) {
            var current = this['variant' + n + 'Choice'];
            if (!current || this.isChoiceSold(n, current.name)) {
                continue;
            }
            var sold = (this.getVariantChoices(n) || []).find(function (choice) {
                return this.isChoiceSold(n, choice.name);
            }, this);
            if (sold) {
                this['variant' + n + 'Choice'] = sold;
            }
        }
    },

    getChosenVariant: function () {
        var allVariants = this.getVariants();
        var variant1Name = this.variant1Choice ? this.variant1Choice.name : null;
        var variant2Name = this.variant2Choice ? this.variant2Choice.name : null;
        var variant3Name = this.variant3Choice ? this.variant3Choice.name : null;

        var variant = allVariants.find(function (v) {
            return v.enabled
                && v.attribute1Choice === variant1Name
                && v.attribute2Choice === variant2Name
                && v.attribute3Choice === variant3Name;
        });

        return variant ? variant.id : this.productConfigData.variants[0].id;
    },

    getVariants: function () {
        return this.productConfigData.variants;
    },

    getSizeAttributeNumber: function () {
        for (var num = 1; num <= 3; num++) {
            var title = this.getStockAttributeTitle(num);
            if (hasValue(title) && /^\s*sizes?\s*$/i.test(title)) {
                return num;
            }
        }
        return null;
    },

    /**
     * The quantity grid (TTI-24064): the sizes, and each combination of the other attributes (usually
     * Color) as a row, in the order the variants are listed. The page shows one row's sizes at a time.
     */
    getQuantityMatrix: function () {
        var sizeNum = this.getSizeAttributeNumber();
        var otherNums = [1, 2, 3].filter(function (num) {
            return num !== sizeNum && hasValue(this.getStockAttributeTitle(num));
        }, this);
        var sizes = [];
        var rows = [];
        var cells = {};

        this.getVariants().forEach(function (variant) {
            if (!variant.enabled) {
                return;
            }
            var size = variant['attribute' + sizeNum + 'Choice'];
            var rowLabel = otherNums.map(function (num) {
                return variant['attribute' + num + 'Choice'];
            }).join(' / ');
            if (sizes.indexOf(size) < 0) {
                sizes.push(size);
            }
            if (rows.indexOf(rowLabel) < 0) {
                rows.push(rowLabel);
            }
            cells[rowLabel + '\u0000' + size] = variant;
        });

        return {
            rowTitle: otherNums.map(function (num) {
                return this.getStockAttributeTitle(num);
            }, this).join(' / '),
            otherNums: otherNums,
            sizes: sizes,
            rows: rows,
            variantAt: function (rowLabel, size) {
                return cells[rowLabel + '\u0000' + size] || null;
            }
        };
    },

    getVariantChoicesOf: function (variant) {
        var choices = {};
        for (var num = 1; num <= 3; num++) {
            if (hasValue(variant['attribute' + num + 'Choice'])) {
                choices[num] = variant['attribute' + num + 'Choice'];
            }
        }
        return choices;
    },

    // The page's published minimum honors a share's own; the product configuration only knows its master's.
    getStockMinQuantity: function () {
        if (typeof stockGlobals !== 'undefined' && stockGlobals.stockMinQuantity !== undefined) {
            return stockGlobals.stockMinQuantity;
        }
        return this.productConfigData.systemOffering ? this.productConfigData.systemOffering.stockMinQuantity : this.productConfigData.stockMinQuantity;
    },

    getSoldAsContent: function () {
        var stockUom = this.productConfigData.systemOffering
            ? this.productConfigData.systemOffering.stockUnitOfMeasure
            : this.productConfigData.stockUnitOfMeasure;

        return stockUom ? ' (' + stockUom + ')' : '';
    },

    getSelectedVariants: function () {
        var choices = new Map();

        if (this.variant1Choice) {
            choices.set(1, this.variant1Choice.name);
        }
        if (this.variant2Choice) {
            choices.set(2, this.variant2Choice.name);
        }
        if (this.variant3Choice) {
            choices.set(3, this.variant3Choice.name);
        }

        return Object.fromEntries(choices.entries());
    },

    setQuoteRequestData: function (data) {
        this.quoteRequestData = data;
    },

    generateQuoteRequestData: function () {
        var SLO_PREFIX = 'SLO';
        var variantsChoices = this.getSelectedVariants();

        var printJobQuoteSpecOverrides = {
            variantsChoices: variantsChoices
        };

        printJobQuoteSpecOverrides.unitStockPriceOverrideAmount = this.unitStockPriceOverrideAmount;
        printJobQuoteSpecOverrides.unitWeightLbsOverrideAmount = this.unitWeightLbsOverrideAmount;
        printJobQuoteSpecOverrides.applyDefaultPriceAndWeight = this.applyDefaultPriceAndWeight;

        var data = {
            systemOfferingSiteShareId: stockGlobals.idWithPrefix && stockGlobals.idWithPrefix.startsWith(SLO_PREFIX) ? -1 : this.productConfigData.id,
            quantity: this.qty,
            printJobQuoteSpecOverrides: printJobQuoteSpecOverrides,
            siteId: stockGlobals.siteId,
            systemId: stockGlobals.systemId,
            offeringId: stockGlobals.offeringId,
            idWithPrefix: stockGlobals.idWithPrefix,
            orderItemId: getUrlParms().reorder || getUrlParms().orderItemId,
            variantId: this.getSelectedVariantId() || getUrlParm('variantId'),
            clientKey: controller.getCookieByName('anonymous-user-cart'),
            decorations: controller.decorationQuoteData()
        };

        this.setQuoteRequestData(data);
        return data;
    },

    getQuantityLabel: function () {
        return 'Quantity';
    },

    addAdditionalField: function (question, answer) {
        this.additionalFields[question] = answer;
    },

    getOfferingName: function () {
        return this.productConfigData.name;
    }
};

function OfferingAdapter (model) {
    this.model = model;
}

OfferingAdapter.prototype = {

    get id () {
        return this.model.productConfigData.id;
    }

};

function StockQuoteAdapter (model, quote) {
    this.model = model;
    this.quote = quote;
    this.quoteRequestData = Object.assign({}, model.quoteRequestData, {
        additionalFields: model.additionalFields
    });

    for (var prop in quote) {
        this[prop] = quote[prop];
    }
}

StockQuoteAdapter.prototype = {

    get jobTotalPriceDisplay () {
        return this.priceDisplay;
    },

    get stockQuote () {
        var totalOunces = this.totalOunces;
        var quantity = this.quantity;

        return {
            totalOunces: totalOunces,
            quantity: quantity
        };
    }

};

function StockQuoteDataAdapter (model, quote) {
    this.model = model;
    this.quote = quote;

    try {
        var hasQuoteErrors = this.quote !== undefined && this.quote.errors !== undefined && this.quote.errors.length > 0;

        if (hasQuoteErrors) {
            var quoteValidationData = JSON.parse(this.quote.errors[0].detail);
            this.quoteValidation = new Validation(quoteValidationData);
        } else if (this.quote.validation) {
            var fieldMessages = this.quote.validation.fieldMessages ? this.quote.validation.fieldMessages.map(function (fm) {
                return {
                    fieldName: fm.fieldName,
                    value: fm.message
                };
            }) : [];
            this.quoteValidation = new Validation({
                globalErrorMessages: this.quote.validation.globalErrorMessages,
                globalInfoMessages: this.quote.validation.globalInfoMessages,
                jobQuoteFieldMessages: fieldMessages
            });
        } else {
            this.quoteValidation = new Validation({});
        }
    } catch (e) {
        this.quoteValidation = new Validation({});
    }
}

StockQuoteDataAdapter.prototype = {

    setProperty: function () {
    },

    addFieldError: function (fieldName, value) {
        this.validation.addFieldError(fieldName, value);
    },

    clearFieldErrors: function (fieldName) {
        this.validation.clearFieldErrors(fieldName);
    },

    addGlobalError: function (error) {
        this.validation.addGlobalError(error);
    },

    clearGlobalErrors: function () {
        this.validation.clearGlobalErrors();
    },

    get validation () {
        return this.quoteValidation;
    },

    get quantity () {
        return this.model.qty;
    },

    get jobSpecOverrides () {
        return this.model.generateQuoteRequestData().printJobQuoteSpecOverrides;
    },

    get variantId () {
        return this.model.getChosenVariant();
    },

    get metadata () {
        return this.model.productConfigData.metadata;
    },

    setAdditionalField: function (question, answer) {
        this.model.addAdditionalField(question, answer);
    },

    get additionalFields () {
        return this.model.additionalFields;
    }

};

function Validation (quoteValidationData) {
    var globalErrorMessages = quoteValidationData.globalErrorMessages || [];

    this.hasGlobalErrorMessages = globalErrorMessages.length > 0;
    this.globalErrorMessages = globalErrorMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var globalInfoMessages = quoteValidationData.globalInfoMessages || [];

    this.hasGlobalInfoMessages = globalInfoMessages.length > 0;
    this.globalInfoMessages = globalInfoMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var jobQuoteFieldMessages = quoteValidationData.jobQuoteFieldMessages || [];

    this.hasJobQuoteMessages = quoteValidationData.length > 0;
    this.jobQuoteFieldMessages = jobQuoteFieldMessages;
}

Validation.prototype = {

    addFieldError: function (fieldName, value) {
        this.jobQuoteFieldMessages.push({ fieldName: fieldName, value: value });
    },

    clearFieldErrors: function (fieldName) {
        var jobQuoteFieldMessages = this.jobQuoteFieldMessages;
        var fieldErrors = jobQuoteFieldMessages.filter(function (msg) {
            return msg.fieldName === fieldName;
        });

        fieldErrors.forEach(function (error) {
            jobQuoteFieldMessages.splice(jobQuoteFieldMessages.indexOf(error), 1);
        });
    },

    addGlobalError: function (error) {
        this.globalErrorMessages.push({ value: error });
        this.hasGlobalErrorMessages = true;
    },

    clearGlobalErrors: function () {
        this.globalErrorMessages = [];
        this.hasGlobalErrorMessages = false;
    }
};

var controller = {
    model: new StockModel(),

    QUOTE_URLS: {
        DEFAULT: '/rest/storefront/products/quotes',
        EXTENDED: '/rest/internal/supplierAdmin/products/quotes/extended',
        CUSTOM: '/rest/internal/supplierAdmin/products/quotes/custom'
    },
    USER_TYPES: {
        SUPPLIER_ADMIN: 'SUPPLIER_ADMIN'
    },

    initializeModelAndDisplay: function (productConfigData) {
        this.model.initialize(productConfigData);
        if (this.decoratedEdit) {
            this.applyDecoratedEdit(this.decoratedEdit);
            this.applyDecoratedEditQuantities(this.decoratedEdit);
        }

        this.initializeAdapters();

        var configChangeDetails = {
            context: 'init',
            category: confUtil.INIT
        };

        this.listenForVariantSelection();
        this.listenForDecorationChanges();

        this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });
            if (this.decoratedEdit) {
                $('.addToCart').text('Update cart');
                if (this.isQuantityMatrix()) {
                    this.matrixRowChanged();
                    this.scheduleMatrixQuote();
                }
            }
            this.announceVariant();
            this.announceDecoration();

            configureEvents.onCalcLoaded();
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.onStockQuoteComplete(configureglobals.cquote != null);
        }.bind(this));

        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.initialize();
        }
    },
    initializeAdapters: function () {
        configureglobals.set('cstockoffering', new OfferingAdapter(this.model));
    },

    // TTI-20903: themes tie product images to variants. The page announces the chosen variant, so a theme can show its
    // image, and a theme asks for a variant, when its image is clicked, so the page selects it as if it were picked.
    announceVariant: function () {
        // In the grid, the color row the shopper is on.
        window.stockVariantEvents.announce(this.proofVariantId());

        // An enclosed white prints on colored goods only, so a method's color limit may now fit the logo, or not.
        if (this.syncDecorationControls()) {
            this.announceDecoration();
            return;
        }

        // Which photo each location is drawn on depends on the variant; proofs already drawn come back from the page's memory or the server's.
        if (this.proofsAsked) {
            var choice = this.decorationChoice();
            if (choice) {
                this.showDecorationProof(choice);
            }
        }
    },

    // TTI-24082: the picker is server-rendered (incStockConfigure.jsp) only for a product with vendor decorations.
    decorationChoice: function () {
        var picker = document.getElementById('decorations');
        if (!picker) {
            return null;
        }
        var decorations = Array.prototype.slice.call(picker.querySelectorAll('.c-decorations-method'))
            .filter(function (select) {
                return select.value !== '';
            })
            .map(function (select) {
                var locationId = Number(select.getAttribute('data-location-id'));
                var size = this.decorationSize(picker, select);
                var decoration = {
                    locationId: locationId,
                    decorationId: Number(select.value),
                    imprintWidthInches: size ? size.width : null,
                    imprintHeightInches: size ? size.height : null
                };
                var logo = this.chosenLogo(picker, locationId);
                if (logo) {
                    decoration.brandedLogoFileId = Number(logo.value);
                }
                if (this.inkKind(select)) {
                    decoration.inkColors = this.changedInks(picker, locationId).map(function (ink) {
                        var color = { pms: ink.pms };
                        if (ink.name) {
                            color.name = ink.name;
                        }
                        if (ink.hex) {
                            color.hex = ink.hex;
                        }
                        return color;
                    });
                }
                return decoration;
            }, this);
        return {
            decorations: decorations,
            brandedLogoFileId: decorations.length > 0 && decorations[0].brandedLogoFileId ? decorations[0].brandedLogoFileId : null
        };
    },

    DECORATION_SIZE_STEP: 0.25,

    // The largest logo that fits the vendor's print area at the logo's own proportions (width / height), and a floor:
    // the method's minimum on the logo's longer side (1 inch when the page has none), or a quarter inch when the
    // largest is under it. The slider moves the logo's longer side in quarter inches from the floor, and its last stop
    // is the largest, even when that is not a quarter: the slider counts stops, not inches, so there is no stretch past
    // the largest that shows the same size.
    decorationSizing: function (maxWidth, maxHeight, aspect, minInches) {
        var floor2 = this.floorToHundredths;
        var step = this.DECORATION_SIZE_STEP;
        var fitWidth = Math.min(maxWidth, maxHeight * aspect);
        var wide = aspect >= 1;
        var max = floor2(wide ? fitWidth : fitWidth / aspect);
        var least = minInches > 0 ? minInches : 1;
        var min = max >= least ? least : max >= step ? step : max;
        var stops = max > min ? Math.ceil((max - min) / step - 1e-9) : 0;
        return { wide: wide, aspect: aspect, min: min, max: max, stops: stops };
    },

    decorationSideAtStop: function (sizing, stop) {
        var at = Math.max(0, Math.min(sizing.stops, Math.round(stop)));
        return at === sizing.stops ? sizing.max : this.floorToHundredths(sizing.min + at * this.DECORATION_SIZE_STEP);
    },

    // The stop at or below a size, so a size carried over from another method never grows.
    decorationStopFor: function (sizing, longSide) {
        if (!(longSide < sizing.max)) {
            return sizing.stops;
        }
        return Math.max(0, Math.floor((longSide - sizing.min) / this.DECORATION_SIZE_STEP + 1e-9));
    },

    decorationSizeAt: function (sizing, longSide) {
        var floor2 = this.floorToHundredths;
        var side = floor2(Math.max(sizing.min, Math.min(sizing.max, longSide)));
        var size = sizing.wide
            ? { width: side, height: floor2(side / sizing.aspect) }
            : { width: floor2(side * sizing.aspect), height: side };
        return size.width > 0 && size.height > 0 ? size : null;
    },

    // Down, so the size never rounds past the vendor's print size.
    floorToHundredths: function (inches) {
        return Math.floor(inches * 100 + 1e-9) / 100;
    },

    decorationLocationCell: function (picker, locationId) {
        return picker.querySelector('.c-decorations-location[data-location-id="' + locationId + '"]');
    },

    chosenMethod: function (select) {
        return select.value === '' ? null : select.querySelector('option[value="' + select.value + '"]');
    },

    // The location's own logo choice; a theme still rendering one logo for the whole item has DECORATIONLOGO.
    chosenLogo: function (picker, locationId) {
        var cell = locationId != null ? this.decorationLocationCell(picker, locationId) : null;
        var own = cell && cell.querySelector('input[name="DECORATIONLOGO' + locationId + '"]:checked');
        return own || picker.querySelector('input[name="DECORATIONLOGO"]:checked');
    },

    // From the logo's picture as the page measured it; without one the logo takes the print area's proportions.
    logoAspect: function (picker, maxWidth, maxHeight, locationId) {
        var logo = this.chosenLogo(picker, locationId);
        var image = logo && picker.querySelector('.c-decorations-logo-image[data-logo-id="' + logo.value + '"]');
        if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
            return image.naturalWidth / image.naturalHeight;
        }
        return maxWidth > 0 && maxHeight > 0 ? maxWidth / maxHeight : 1;
    },

    decorationSizingFor: function (picker, select) {
        var method = this.chosenMethod(select);
        var maxWidth = method ? Number(method.getAttribute('data-max-width-inches')) : 0;
        var maxHeight = method ? Number(method.getAttribute('data-max-height-inches')) : 0;
        if (!(maxWidth > 0 && maxHeight > 0)) {
            return null;
        }
        return this.decorationSizing(
            maxWidth, maxHeight, this.logoAspect(picker, maxWidth, maxHeight, select.getAttribute('data-location-id')),
            Number(method.getAttribute('data-min-inches'))
        );
    },

    decorationSize: function (picker, select) {
        var sizing = this.decorationSizingFor(picker, select);
        var cell = this.decorationLocationCell(picker, select.getAttribute('data-location-id'));
        var range = cell && cell.querySelector('.c-decorations-size-range');
        if (!sizing || !range) {
            return null;
        }
        return this.decorationSizeAt(sizing, range.getAttribute('data-chosen') === 'true' ? this.decorationSideAtStop(sizing, Number(range.value)) : sizing.max);
    },

    // Shows each chosen location's size slider, at the largest size that fits unless the customer moved it. A size the
    // customer chose stays when the method changes, down to the new method's largest when it is smaller. True when a
    // location's method changed because it can't print the logo's colors.
    syncDecorationControls: function () {
        var picker = document.getElementById('decorations');
        if (!picker) {
            return false;
        }
        var moved = false;
        Array.prototype.slice.call(picker.querySelectorAll('.c-decorations-method')).forEach(function (select) {
            var cell = this.decorationLocationCell(picker, select.getAttribute('data-location-id'));
            if (!cell) {
                return;
            }
            var before = select.value;
            this.syncColorLimits(picker, select, cell);
            moved = moved || select.value !== before;
            var logos = cell.querySelector('.c-decorations-logos');
            if (logos) {
                logos.hidden = select.value === '' && !cell.getAttribute('data-colors-moved');
            }
            this.syncInks(picker, select);
            var sizeCell = cell.querySelector('.c-decorations-size');
            var sizing = this.decorationSizingFor(picker, select);
            if (sizeCell) {
                sizeCell.hidden = !sizing;
                if (sizing) {
                    var range = sizeCell.querySelector('.c-decorations-size-range');
                    var chosen = range.getAttribute('data-chosen') === 'true';
                    var stop = chosen ? this.decorationStopFor(sizing, Number(range.getAttribute('data-inches'))) : sizing.stops;
                    range.min = '0';
                    range.max = String(sizing.stops);
                    range.step = '1';
                    range.value = String(stop);
                    if (chosen) {
                        range.setAttribute('data-inches', String(this.decorationSideAtStop(sizing, stop)));
                    }
                    this.showDecorationSize(sizeCell, this.decorationSizeAt(sizing, this.decorationSideAtStop(sizing, stop)));
                }
            }
        }, this);
        return moved;
    },

    // TTI-24082: a method prints at most its data-max-colors. One that can't print the chosen logo is disabled, saying so,
    // and the location moves off it to the first that can (else to none, keeping the logos open to choose another), and back
    // once the logo fits again. The server refuses it too.
    syncColorLimits: function (picker, select, cell) {
        var locationId = select.getAttribute('data-location-id');
        var logo = this.chosenLogo(picker, locationId);
        var colors = this.logoInks(picker, locationId, this.limitOnWhiteGoods()).length || Number(logo && logo.getAttribute('data-color-count')) || 0;
        var methods = Array.prototype.slice.call(select.querySelectorAll('option')).filter(function (option) {
            return option.value !== '';
        });
        var unfit = [];
        methods.forEach(function (option) {
            var name = option.getAttribute('data-name') || option.textContent;
            var max = Number(option.getAttribute('data-max-colors'));
            option.setAttribute('data-name', name);
            option.disabled = max > 0 && colors > max;
            option.textContent = option.disabled ? name + ' (prints up to ' + max + (max === 1 ? ' color)' : ' colors)') : name;
            if (option.disabled) {
                unfit.push(name + ' prints up to ' + max);
            }
        });
        var fitting = methods.filter(function (option) {
            return !option.disabled;
        });
        var movedFrom = cell.getAttribute('data-colors-moved');
        var chosen = this.chosenMethod(select);
        if (chosen && chosen.disabled) {
            cell.setAttribute('data-colors-moved', chosen.value);
            cell.setAttribute('data-colors-moved-to', fitting.length ? fitting[0].value : '');
            select.value = fitting.length ? fitting[0].value : '';
        } else if (movedFrom) {
            var back = select.querySelector('option[value="' + movedFrom + '"]');
            if (select.value === cell.getAttribute('data-colors-moved-to') && back && !back.disabled) {
                select.value = movedFrom;
            }
            if (select.value !== cell.getAttribute('data-colors-moved-to') || !back || !back.disabled) {
                cell.setAttribute('data-colors-moved', '');
                cell.setAttribute('data-colors-moved-to', '');
            }
        }
        var note = cell.querySelector('.c-decorations-colors-note');
        if (note) {
            var shown = unfit.length > 0 && (select.value !== '' || Boolean(cell.getAttribute('data-colors-moved')));
            note.textContent = shown ? 'Your logo has ' + colors + ' colors; ' + unfit.join(', ') + '.'
                + (fitting.length ? '' : ' Choose a logo with fewer colors to decorate here.') : '';
            note.hidden = !shown;
        }
    },

    showDecorationSize: function (sizeCell, size) {
        var label = sizeCell.querySelector('.c-decorations-size-value');
        var range = sizeCell.querySelector('.c-decorations-size-range');
        label.textContent = size ? this.inchesText(size.width) + ' \u00D7 ' + this.inchesText(size.height) + ' in' : '';
        if (range) {
            range.setAttribute('aria-valuetext', label.textContent);
        }
    },

    // In hundredths, as the vendor's purchase order records it: "3 × 0.59 in", never rounded to a fraction it does not print at.
    inchesText: function (inches) {
        return String(Number(Number(inches).toFixed(2)));
    },

    announceDecoration: function () {
        this.syncDecorationControls();
        var choice = this.decorationChoice();
        if (choice) {
            window.stockVariantEvents.raise('PRODUCT_DECORATION_CHANGED', choice);
            this.showDecorationProof(choice);
            this.requoteForDecorations(choice);
        }
    },

    // The price carries the vendor's decoration charges, so a decoration that changes them asks for the price again.
    requoteForDecorations: function (choice) {
        var key = JSON.stringify(choice.decorations);
        if (this.isQuantityMatrix()) {
            // Each size line is priced with the decorations, so a change asks for every line's price again.
            if (this.matrixDecorations !== undefined && this.matrixDecorations !== key) {
                this.scheduleMatrixQuote();
            }
            this.matrixDecorations = key;
            return;
        }
        var quoted = this.model.quoteRequestData && this.model.quoteRequestData.decorations;
        if (!this.model.productConfigData || !this.model.quoteRequestData || JSON.stringify(quoted || []) === key) {
            return;
        }
        this.updateQuote({ context: 'decoration', category: confUtil.FIELD_CHANGE });
    },

    // The decorations a quote is asked for, so its price includes their charges; none on a page without the picker.
    decorationQuoteData: function () {
        var choice = this.decorationChoice();
        return choice ? choice.decorations : undefined;
    },

    // TTI-24082: common PMS (Pantone) inks, with on-screen colors that are approximate. A code not listed is taken as typed.
    PMS_COLORS: [
        { pms: 'Black C', name: 'Black', hex: '#2D2926' },
        { pms: '186 C', name: 'Red', hex: '#C8102E' },
        { pms: '032 C', name: 'Bright red', hex: '#EF3340' },
        { pms: '202 C', name: 'Maroon', hex: '#862633' },
        { pms: '021 C', name: 'Orange', hex: '#FE5000' },
        { pms: '151 C', name: 'Orange', hex: '#FF8200' },
        { pms: '116 C', name: 'Yellow', hex: '#FFCD00' },
        { pms: '123 C', name: 'Gold', hex: '#FFC72C' },
        { pms: '871 C', name: 'Metallic gold', hex: '#84754E' },
        { pms: '877 C', name: 'Metallic silver', hex: '#8A8D8F' },
        { pms: '354 C', name: 'Green', hex: '#00B140' },
        { pms: '349 C', name: 'Forest green', hex: '#046A38' },
        { pms: '375 C', name: 'Lime green', hex: '#97D700' },
        { pms: '286 C', name: 'Royal blue', hex: '#0033A0' },
        { pms: '300 C', name: 'Blue', hex: '#005EB8' },
        { pms: '2925 C', name: 'Sky blue', hex: '#009CDE' },
        { pms: '282 C', name: 'Navy', hex: '#041E42' },
        { pms: '320 C', name: 'Teal', hex: '#009CA6' },
        { pms: '268 C', name: 'Purple', hex: '#582C83' },
        { pms: '212 C', name: 'Pink', hex: '#F04E98' },
        { pms: '469 C', name: 'Brown', hex: '#693F23' },
        { pms: 'Cool Gray 7 C', name: 'Gray', hex: '#97999B' },
        { pms: 'Cool Gray 11 C', name: 'Dark gray', hex: '#53565A' },
        { pms: 'White', name: 'White', hex: '#FFFFFF' },
        { pms: '185 C', name: 'Red', hex: '#E4002B' },
        { pms: '1795 C', name: 'Red', hex: '#D22630' },
        { pms: '200 C', name: 'Red', hex: '#BA0C2F' },
        { pms: '201 C', name: 'Cardinal red', hex: '#9D2235' },
        { pms: '7427 C', name: 'Maroon', hex: '#97233F' },
        { pms: '1505 C', name: 'Orange', hex: '#FF6900' },
        { pms: '109 C', name: 'Yellow', hex: '#FFD100' },
        { pms: '7406 C', name: 'Gold', hex: '#F1C400' },
        { pms: '347 C', name: 'Green', hex: '#009A44' },
        { pms: '355 C', name: 'Green', hex: '#009639' },
        { pms: '3425 C', name: 'Dark green', hex: '#006341' },
        { pms: '293 C', name: 'Blue', hex: '#003DA5' },
        { pms: '2935 C', name: 'Blue', hex: '#0057B8' },
        { pms: '285 C', name: 'Blue', hex: '#0072CE' },
        { pms: '2945 C', name: 'Blue', hex: '#004C97' },
        { pms: '299 C', name: 'Light blue', hex: '#00A3E0' },
        { pms: '281 C', name: 'Navy', hex: '#00205B' },
        { pms: '289 C', name: 'Navy', hex: '#0C2340' },
        { pms: '3135 C', name: 'Teal', hex: '#008EAA' },
        { pms: '266 C', name: 'Purple', hex: '#753BBD' },
        { pms: '2685 C', name: 'Purple', hex: '#330072' },
        { pms: 'Rhodamine Red C', name: 'Magenta', hex: '#E10098' },
        { pms: '4625 C', name: 'Dark brown', hex: '#4F2C1D' },
        { pms: 'Black 6 C', name: 'Rich black', hex: '#101820' }
    ],
    COMMON_PMS: 24,

    // TTI-24082: "ink" for a screen- or pad-printed (or color-priced) method, "thread" for embroidery, else none: full color.
    inkKind: function (select) {
        var method = this.chosenMethod(select);
        var kind = method && method.getAttribute('data-ink-kind');
        if (kind === 'ink' || kind === 'thread') {
            return kind;
        }
        return method && method.getAttribute('data-needs-colors') === 'true' ? 'ink' : null;
    },

    inkCell: function (picker, locationId) {
        var cell = this.decorationLocationCell(picker, locationId);
        return cell && cell.querySelector('.c-decorations-inks');
    },

    // Goods are white when a chosen variant names white: "White", or one word and "White", as "Bright White". The server decides the same way.
    isWhiteGoods: function () {
        var row = this.isQuantityMatrix && this.isQuantityMatrix() ? this.matrixRowVariant() : null;
        return row ? this.isWhiteVariant(row) : this.namesWhite(this.model && this.model.getSelectedVariants ? this.model.getSelectedVariants() : {});
    },

    isWhiteVariant: function (variant) {
        return this.namesWhite({ 1: variant.attribute1Choice, 2: variant.attribute2Choice, 3: variant.attribute3Choice });
    },

    namesWhite: function (chosen) {
        return Object.keys(chosen || {}).some(function (num) {
            return /^(\S+ )?white$/.test(String(chosen[num] || '').trim().toLowerCase().replace(/\s+/g, ' '));
        });
    },

    // What a method's color limit is judged on. Every grid line takes the same decoration, so there the goods are white only
    // when the row shown and every row with a quantity are: one colored row prints the logo's enclosed white.
    limitOnWhiteGoods: function () {
        if (!(this.isQuantityMatrix && this.isQuantityMatrix())) {
            return this.isWhiteGoods();
        }
        return this.isWhiteGoods() && this.matrixEntries().every(function (entry) {
            return this.isWhiteVariant(entry.variant);
        }, this);
    },

    // The chosen logo's inks (as an admin confirmed them, else as detected), less an enclosed white on white goods:
    // whiteGoods when given, else the variant or grid row shown.
    logoInks: function (picker, locationId, whiteGoods) {
        var logo = this.chosenLogo(picker, locationId);
        var inks = [];
        try {
            inks = JSON.parse((logo && logo.getAttribute('data-inks')) || '[]') || [];
        } catch (e) {
            inks = [];
        }
        var white = whiteGoods === undefined ? this.isWhiteGoods() : whiteGoods;
        return inks.filter(function (ink) {
            return !(white && ink.enclosed);
        });
    },

    // The shopper's change of the logo's inks at a location, kept while that logo stays chosen; null when unchanged.
    inkChange: function (picker, locationId) {
        this.inkChanges = this.inkChanges || {};
        var change = this.inkChanges[locationId];
        var logo = this.chosenLogo(picker, locationId);
        if (!change || change.logoId !== (logo ? logo.value : null) || change.inks.length !== this.logoInks(picker, locationId).length) {
            return null;
        }
        return change;
    },

    inkKey: function (ink) {
        return String(ink.pms || ink.name || '').trim().toLowerCase();
    },

    // The inks to send: the shopper's, when they differ from the logo's; none prints the logo's.
    changedInks: function (picker, locationId) {
        var change = this.inkChange(picker, locationId);
        if (!change) {
            return [];
        }
        var own = this.logoInks(picker, locationId).map(this.inkKey);
        var same = change.inks.every(function (ink, at) {
            return this.inkKey(ink) === own[at];
        }, this);
        return same ? [] : change.inks;
    },

    inksShown: function (picker, locationId) {
        var change = this.inkChange(picker, locationId);
        return change ? change.inks : this.logoInks(picker, locationId);
    },

    startInkChange: function (picker, locationId) {
        var logo = this.chosenLogo(picker, locationId);
        this.inkChanges = this.inkChanges || {};
        if (!this.inkChange(picker, locationId)) {
            this.inkChanges[locationId] = {
                logoId: logo ? logo.value : null,
                inks: this.logoInks(picker, locationId).map(function (ink) {
                    return { pms: ink.pms, name: ink.name, hex: ink.hex, enclosed: ink.enclosed };
                })
            };
        }
        this.inkChanges[locationId].swapping = null;
    },

    resetInks: function (locationId) {
        this.inkChanges = this.inkChanges || {};
        delete this.inkChanges[locationId];
    },

    swapInk: function (picker, locationId, index) {
        var change = this.inkChange(picker, locationId);
        if (change) {
            change.swapping = change.swapping === index ? null : index;
        }
    },

    // The one ink being swapped takes the color picked; the count stays the logo's.
    pickInk: function (picker, locationId, pms) {
        var change = this.inkChange(picker, locationId);
        if (!change || change.swapping === null || change.swapping === undefined) {
            return false;
        }
        var color = this.pmsColor(pms, this.logoInks(picker, locationId));
        var others = change.inks.filter(function (ink, at) {
            return at !== change.swapping;
        });
        if (!color.pms || others.some(function (ink) {
            return this.inkKey(ink) === this.inkKey(color);
        }, this)) {
            growlMessages.showErrorMessage(this.inkText(color) + ' is already one of the colors.');
            return false;
        }
        change.inks[change.swapping] = { pms: color.pms, name: color.name, hex: color.hex, enclosed: color.enclosed };
        change.swapping = null;
        if (this.changedInks(picker, locationId).length === 0) {
            this.resetInks(locationId);
        }
        return true;
    },

    // The logo's own ink, else a listed PMS, else the code as typed. own: the logo's inks.
    pmsColor: function (pms, own) {
        var wanted = this.pmsCode(pms).toLowerCase();
        return (own || []).concat(this.PMS_COLORS).find(function (color) {
            return String(color.pms || '').toLowerCase() === wanted;
        }) || { pms: this.pmsCode(pms), name: null, hex: null };
    },

    // "715" and "715c" are PMS 715 C, the coated ink a bare number means.
    pmsCode: function (pms) {
        var code = String(pms || '').trim().replace(/^pms\s*/i, '');
        if (/^\d+$/.test(code)) {
            return code + ' C';
        }
        return /^\d+\s*[cum]$/i.test(code) ? code.toUpperCase().replace(/\s*([CUM])$/, ' $1') : code;
    },

    // The search's matches by code or name, else the common inks, the logo's own inks first; a code typed that is not listed is offered.
    inkMatches: function (query, own) {
        var first = (own || []).filter(function (ink) {
            return typeof ink.pms === 'string' && ink.pms.trim() !== '';
        }).filter(function (ink, at, valid) {
            return valid.findIndex(function (other) {
                return other.pms.toLowerCase() === ink.pms.toLowerCase();
            }) === at;
        });
        var withOwn = function (colors) {
            return first.concat(colors.filter(function (color) {
                return !first.some(function (ink) {
                    return ink.pms.toLowerCase() === color.pms.toLowerCase();
                });
            }));
        };
        var wanted = String(query || '').trim().toLowerCase().replace(/^pms\s*/, '');
        var code = this.pmsCode(query).toLowerCase();
        if (!wanted) {
            return withOwn(this.PMS_COLORS.slice(0, this.COMMON_PMS));
        }
        var found = withOwn(this.PMS_COLORS).filter(function (color) {
            return color.pms.toLowerCase().indexOf(wanted) === 0 || color.pms.toLowerCase() === code || (color.name && String(color.name).toLowerCase().indexOf(wanted) >= 0);
        });
        if (/\d/.test(wanted) && !found.some(function (color) {
            return color.pms.toLowerCase().indexOf(wanted) === 0 || color.pms.toLowerCase() === code;
        })) {
            found = found.concat([{ pms: this.pmsCode(query), name: null, hex: null }]);
        }
        return found;
    },

    swatch: function (color) {
        return '<span class="c-decorations-ink-swatch"' + (color.hex ? ' style="background: ' + strWeb(color.hex) + '"' : ' style="background: repeating-linear-gradient(45deg, #ddd, #ddd 3px, #fff 3px, #fff 6px)"')
            + ' aria-hidden="true"></span>';
    },

    inkText: function (color) {
        if (!color.pms) {
            return color.name || 'Logo color';
        }
        var code = color.pms === 'White' ? 'White' : 'PMS ' + color.pms;
        return color.name && color.pms !== 'White' ? code + ' ' + color.name : code;
    },

    renderInkOptions: function (picker, locationId) {
        var inks = this.inkCell(picker, locationId);
        var options = inks && inks.querySelector('.c-decorations-ink-options');
        if (!options) {
            return;
        }
        var search = inks.querySelector('.c-decorations-ink-search');
        var change = this.inkChange(picker, locationId);
        var replacing = change && change.inks[change.swapping] ? this.inkKey(change.inks[change.swapping]) : null;
        options.innerHTML = this.inkMatches(search ? search.value : '', this.logoInks(picker, locationId)).map(function (color) {
            var pressed = this.inkKey(color) === replacing;
            return '<button type="button" class="c-decorations-ink-option" data-location-id="' + strWeb(String(locationId)) + '" data-pms="' + strWeb(color.pms)
                + '" aria-pressed="' + pressed + '" title="' + strWeb(this.inkText(color)) + '">' + this.swatch(color) + strWeb(this.inkText(color)) + '</button>';
        }, this).join('');
    },

    // "Prints in 2 colors: PMS 186 C Red, PMS 282 C Navy (from your logo)", with "Change ink colors" to swap one; embroidery says thread.
    syncInks: function (picker, select) {
        var locationId = select.getAttribute('data-location-id');
        var cell = this.inkCell(picker, locationId);
        if (!cell) {
            return;
        }
        var kind = select.value !== '' ? this.inkKind(select) : null;
        cell.hidden = !kind;
        if (!kind) {
            return;
        }
        var inks = this.inksShown(picker, locationId);
        var change = this.inkChange(picker, locationId);
        var changed = this.changedInks(picker, locationId).length > 0;
        var noun = kind === 'thread' ? ' thread color' : ' color';
        var verb = kind === 'thread' ? 'Stitched in ' : 'Prints in ';
        var title = cell.querySelector('.c-decorations-inks-title');
        if (title) {
            title.textContent = inks.length ? verb + inks.length + noun + (inks.length === 1 ? '' : 's') + ':' : verb + 'your logo\'s colors';
        }
        var chips = cell.querySelector('.c-decorations-ink-chosen');
        if (chips) {
            chips.innerHTML = inks.map(function (ink, at) {
                var swapping = change && change.swapping === at;
                return '<li class="c-decorations-ink' + (swapping ? ' c-decorations-ink--swapping' : '') + '">' + this.swatch(ink) + strWeb(this.inkText(ink))
                    + (change ? ' <button type="button" class="c-decorations-ink-swap" data-location-id="' + strWeb(String(locationId)) + '" data-index="' + at
                        + '" aria-pressed="' + Boolean(swapping) + '" aria-label="Change ' + strWeb(this.inkText(ink)) + '">Change</button>' : '') + '</li>';
            }, this).join('');
        }
        var source = cell.querySelector('.c-decorations-ink-source');
        if (source) {
            source.textContent = inks.length ? changed ? '(your colors)' : '(from your logo)' : '';
        }
        var notes = [];
        var method = this.chosenMethod(select);
        var each = kind === 'ink' && method && method.getAttribute('data-pms-each');
        if (each && change) {
            notes.push('Each color you change adds $' + Number(each).toFixed(2) + ' for PMS matching.');
        }
        var note = cell.querySelector('.c-decorations-ink-note');
        if (note) {
            note.textContent = notes.join(' ');
            note.hidden = notes.length === 0;
        }
        var start = cell.querySelector('.c-decorations-ink-change');
        if (start) {
            start.hidden = !inks.length || Boolean(change);
            start.textContent = kind === 'thread' ? 'Change thread colors' : 'Change ink colors';
        }
        var reset = cell.querySelector('.c-decorations-ink-reset');
        if (reset) {
            reset.hidden = !change;
        }
        var choose = cell.querySelector('.c-decorations-ink-picker');
        var swapping = change && change.swapping !== null && change.swapping !== undefined;
        if (choose) {
            choose.hidden = !swapping;
            var prompt = choose.querySelector('.c-decorations-ink-picker-title');
            if (prompt && swapping) {
                prompt.textContent = 'Choose a color in place of ' + this.inkText(change.inks[change.swapping]);
            }
        }
        if (swapping) {
            this.renderInkOptions(picker, locationId);
        }
    },

    // The grid's lines each carry their own charges; the same charge on several lines shows once, with their pieces and total.
    sumCharges: function (perLine) {
        var byLabel = {};
        var order = [];
        perLine.forEach(function (lines) {
            (lines || []).forEach(function (charge) {
                var key = charge.kind + '|' + charge.label + '|' + charge.unitPrice;
                if (!byLabel[key]) {
                    byLabel[key] = Object.assign({}, charge, { quantity: 0, total: 0 });
                    order.push(key);
                }
                byLabel[key].quantity += Number(charge.quantity) || 0;
                byLabel[key].total = Math.round((byLabel[key].total + Number(charge.total || 0)) * 100) / 100;
            });
        });
        return order.map(function (key) {
            return byLabel[key];
        });
    },

    // The price's decoration charges, under the price: what each piece comes to, the decorated pieces, then each location's
    // charges with the location named once. totals: { total, pieces } of the quote, or of the grid's lines together.
    decorationChargesHtml: function (charges, totals) {
        if (!charges || !charges.length) {
            return '';
        }
        var money = function (amount) {
            return '$' + Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };
        var row = function (kind, location, what, amount, extra) {
            return '<div class="c-decorations-charge' + (extra || '') + '"' + (kind ? ' data-kind="' + strWeb(kind) + '"' : '') + '>'
                + '<span class="c-decorations-charge-location">' + strWeb(location) + '</span>'
                + '<span class="c-decorations-charge-label">' + strWeb(what) + '</span>'
                + '<span class="c-decorations-charge-amount">' + money(amount) + '</span></div>';
        };
        var html = '<div class="c-decorations-charges">';
        var total = totals ? Number(totals.total) : NaN;
        var pieces = totals ? Number(totals.pieces) : 0;
        if (total > 0 && pieces > 0) {
            var chargesTotal = charges.reduce(function (sum, charge) {
                return sum + Number(charge.total || 0);
            }, 0);
            html += '<p class="c-decorations-price-each">' + money(total / pieces) + ' each \u00B7 ' + pieces + (pieces === 1 ? ' piece' : ' pieces') + '</p>';
            html += row(null, pieces + (pieces === 1 ? ' piece' : ' pieces') + ', decorated', '', total - chargesTotal, ' c-decorations-charge--base');
        }
        var previous = null;
        charges.forEach(function (charge) {
            var location = charge.locationId === previous ? '' : charge.locationName || '';
            previous = charge.locationId;
            html += row(charge.kind, location, this.chargeDescription(charge), charge.total);
        }, this);
        return html + '</div>';
    },

    // As the server words a charge line: "setup (one time)", "additional location, $4.67 × 60", "PMS match, 2 colors (one time)".
    chargeDescription: function (charge) {
        var units = Number(charge.quantity) || 1;
        if (charge.kind === 'setup') {
            return units > 1 ? 'setup, ' + units + ' colors (one time)' : 'setup (one time)';
        }
        if (charge.kind === 'pmsMatch') {
            return 'PMS match, ' + units + (units === 1 ? ' color' : ' colors') + ' (one time)';
        }
        if (charge.kind === 'additionalLocationRun' && charge.unitPrice != null) {
            return 'additional location, $' + Number(charge.unitPrice).toFixed(2) + (units > 1 ? ' \u00D7 ' + units : '');
        }
        return charge.description || charge.label || '';
    },

    // A slider move re-renders the proof once it settles, not on every step.
    announceDecorationSoon: function () {
        clearTimeout(this.decorationTimer);
        this.decorationTimer = setTimeout(this.announceDecorationLater, 350);
    },

    NO_PROOFS: { photos: [], defaultLocationId: null },
    PROOFS_REMEMBERED: 24,

    // The customer's logo on the product: one proof per photo, every decorated location with an area drawn on the photo
    // chosen for it, asked for in one request. A choice seen before (a color picked again, the back button) is not asked again.
    showDecorationProof: function (choice) {
        var picker = document.getElementById('decorations');
        var cell = picker && picker.querySelector('.c-decorations-proof');
        if (!cell) {
            return;
        }
        var shown = choice.decorations.filter(function (decoration) {
            var option = picker.querySelector('#DECORATIONDD' + decoration.locationId + ' option[value="' + decoration.decorationId + '"]');
            return option && option.getAttribute('data-proof') === 'true';
        });
        var request = this.dropProofsOnTheirWay();
        this.proofsAsked = true;
        var variantId = this.proofVariantId();
        var show = function (proofs) {
            if (request !== this.proofRequests) {
                return;
            }
            this.showProofUpdating(false);
            this.presentDecorationProof(proofs, shown);
            this.proofsShown = { variantId: variantId, proofs: proofs };
        }.bind(this);
        if (shown.length === 0) {
            show(this.NO_PROOFS);
            return;
        }
        var body = {
            variantId: variantId,
            brandedLogoFileId: choice.brandedLogoFileId,
            decorations: shown.map(function (decoration) {
                var shownAs = {
                    locationId: decoration.locationId,
                    decorationId: decoration.decorationId,
                    widthInches: decoration.imprintWidthInches,
                    heightInches: decoration.imprintHeightInches
                };
                if (decoration.brandedLogoFileId && decoration.brandedLogoFileId !== choice.brandedLogoFileId) {
                    shownAs.brandedLogoFileId = decoration.brandedLogoFileId;
                }
                return shownAs;
            })
        };
        var key = JSON.stringify(body);
        var known = this.rememberedProofs(key);
        if (known) {
            show(known);
            return;
        }
        this.showProofUpdating(true);
        this.showProofsStale(variantId, shown);
        this.requestProofs(body).then(function (proofs) {
            if (!proofs) {
                show(this.NO_PROOFS);
                return null;
            }
            return this.showAsTheyLoad(proofs, show);
        }.bind(this)).then(function (proofs) {
            if (proofs && !proofs.dropped) {
                this.rememberProofs(key, proofs);
            }
        }.bind(this));
    },

    // While new proofs are drawn the theme hears at once that the ones it shows are stale (updating: true). For another
    // variant they all go, but for a photo of the whole product, which every color shares, so the gallery shows the new
    // color's plain photo rather than the old color's mockup; for a new size, logo or location they stay, marked updating.
    showProofsStale: function (variantId, decorations) {
        var before = this.proofsShown;
        var photos = before ? before.proofs.photos || [] : [];
        if (before && before.variantId !== variantId) {
            photos = photos.filter(function (photo) {
                return photo.variantMatched === false && !photo.variantLabel;
            });
        }
        var stale = { photos: photos, defaultLocationId: before ? before.proofs.defaultLocationId : null };
        var detail = this.decorationProofDetail(stale, decorations);
        detail.updating = true;
        this.announceDecorationProof(detail);
        this.proofsShown = { variantId: variantId, proofs: stale };

        var picker = document.getElementById('decorations');
        var cell = picker && picker.querySelector('.c-decorations-proof');
        var imageElement = cell && cell.querySelector('.c-decorations-proof-image');
        if (!imageElement) {
            return;
        }
        var note = cell.querySelector('.c-decorations-proof-note');
        cell.style.display = '';
        imageElement.hidden = !photos.length;
        if (photos.length) {
            imageElement.src = photos[0].image;
        } else if (note) {
            note.hidden = true;
        }
    },

    PROOF_IMAGE_WAIT: 10000,

    // The lead proof shows as soon as its picture loads (or after PROOF_IMAGE_WAIT), the others following in the
    // gallery as they load. A proof whose picture will not load is then left out, so the page and the gallery keep the
    // plain photo instead of a broken one. Resolves with the proofs that loaded, marked dropped when any did not.
    showAsTheyLoad: function (proofs, show) {
        var checks = (proofs.photos || []).map(function (photo) {
            return this.imageLoads(photo.image);
        }, this);
        var loaded = this.withLoadedImages(proofs, checks);
        return (checks.length ? checks[0] : Promise.resolve(false)).then(function (leadLoads) {
            if (leadLoads) {
                show(proofs);
            }
            return loaded.then(function (kept) {
                if (!leadLoads || kept.dropped) {
                    show(kept);
                }
                return kept;
            });
        });
    },

    withLoadedImages: function (proofs, checks) {
        var all = proofs.photos || [];
        return Promise.all(checks || all.map(function (photo) {
            return this.imageLoads(photo.image);
        }, this)).then(function (loaded) {
            var photos = all.filter(function (photo, at) {
                return loaded[at];
            });
            return Object.assign({}, proofs, { photos: photos, dropped: photos.length < all.length });
        });
    },

    // True when the picture loads, or is still loading after a while; false only when it fails.
    imageLoads: function (url) {
        if (typeof Image !== 'function') {
            return Promise.resolve(true);
        }
        var wait = this.PROOF_IMAGE_WAIT;
        return new Promise(function (resolve) {
            var image = new Image();
            var timer = setTimeout(function () {
                resolve(true);
            }, wait);
            image.onload = function () {
                clearTimeout(timer);
                resolve(true);
            };
            image.onerror = function () {
                clearTimeout(timer);
                resolve(false);
            };
            image.src = url;
        }).catch(function () {
            return false;
        });
    },

    rememberedProofs: function (key) {
        var memory = this.proofMemory;
        return memory && Object.prototype.hasOwnProperty.call(memory.byKey, key) ? memory.byKey[key] : null;
    },

    rememberProofs: function (key, proofs) {
        var memory = this.proofMemory = this.proofMemory || { keys: [], byKey: {}};
        if (!Object.prototype.hasOwnProperty.call(memory.byKey, key)) {
            memory.keys.push(key);
        }
        memory.byKey[key] = proofs;
        while (memory.keys.length > this.PROOFS_REMEMBERED) {
            delete memory.byKey[memory.keys.shift()];
        }
    },

    requestProofs: function (body) {
        var pending = this.pendingProofs;
        return tbg.apiV2({
            url: '/products/v2/' + encodeURIComponent(stockGlobals.idWithPrefix) + '/decorationProof',
            method: 'POST',
            contentType: 'application/json',
            beforeSend: function (xhr) {
                pending.push(xhr);
            },

            // A proof is a courtesy: without one the page says nothing rather than showing an error.
            suppressDefaultMessages: true,
            customErrorHandler: function () {
                return null;
            },
            data: JSON.stringify(body)
        }).then(function (response) {
            var content = response && response.content;
            return content && Array.isArray(content.photos) ? {
                photos: content.photos.filter(function (photo) {
                    return photo && photo.image;
                }),
                defaultLocationId: content.defaultLocationId == null ? null : content.defaultLocationId
            } : null;
        });
    },

    // Proofs still on their way are for an old choice: they are cancelled, and dropped should they answer anyway.
    dropProofsOnTheirWay: function () {
        (this.pendingProofs || []).forEach(function (xhr) {
            if (xhr && xhr.abort) {
                xhr.abort();
            }
        });
        this.pendingProofs = [];
        this.proofRequests = (this.proofRequests || 0) + 1;
        return this.proofRequests;
    },

    // From the first slider move until the proof for the latest choice arrives, the proof is marked as updating.
    showProofUpdating: function (updating) {
        var picker = document.getElementById('decorations');
        var cell = picker && picker.querySelector('.c-decorations-proof');
        if (!cell) {
            return;
        }
        if (updating) {
            cell.classList.add('c-decorations-proof--updating');
        } else {
            cell.classList.remove('c-decorations-proof--updating');
        }
        cell.setAttribute('aria-busy', updating ? 'true' : 'false');
        var status = cell.querySelector('.c-decorations-proof-status');
        if (status) {
            status.hidden = !updating;
        }
    },

    // The page's own preview is the first photo, the one with the default location. A theme that shows the proofs in its
    // gallery cancels the event; the page then marks its preview in-gallery, which its style shows only as a small copy
    // at phone widths, where the gallery is off screen beside the controls, and as the warnings.
    presentDecorationProof: function (proofs, decorations) {
        var picker = document.getElementById('decorations');
        var cell = picker && picker.querySelector('.c-decorations-proof');
        if (!cell) {
            return;
        }
        var photos = (proofs && proofs.photos) || [];
        var first = photos[0];
        var inksNote = first ? this.proofInksNote(photos, decorations || []) : null;
        var detail = this.decorationProofDetail(proofs, decorations || []);
        if (inksNote) {
            detail.inksNote = inksNote;
        }
        var themeShowsIt = !this.announceDecorationProof(detail);
        var warning = cell.querySelector('.c-decorations-proof-warning');
        var note = cell.querySelector('.c-decorations-proof-note');
        var imageElement = cell.querySelector('.c-decorations-proof-image');
        var warnings = photos.reduce(function (all, photo) {
            return all.concat(photo.resolutionWarnings || []);
        }, []).filter(function (text, index, all) {
            return text && all.indexOf(text) === index;
        });
        if (inksNote) {
            warnings.push(inksNote);
        }
        cell.style.display = first ? '' : 'none';
        this.toggleClass(cell, 'c-decorations-proof--in-gallery', themeShowsIt);
        this.toggleClass(cell, 'c-decorations-proof--warned', warnings.length > 0);
        imageElement.hidden = !first;
        if (first) {
            imageElement.src = first.image;
        }
        if (note) {
            note.textContent = first && first.variantMatched === false && first.variantLabel ? 'Shown in ' + first.variantLabel : '';
            note.hidden = !note.textContent;
        }
        warning.textContent = warnings.join(' ');
        warning.hidden = warnings.length === 0;
    },

    // The renderer draws the logo's own colors, so a proof never shows colors the shopper changed; the page says so.
    proofInksNote: function (photos, decorations) {
        var drawn = photos.reduce(function (all, photo) {
            return all.concat(photo.locationIds || []);
        }, []);
        var changed = decorations.some(function (decoration) {
            return decoration.inkColors && decoration.inkColors.length > 0 && drawn.indexOf(decoration.locationId) >= 0;
        });
        return changed ? 'The preview shows your logo\'s own colors. Your order uses the colors you chose.' : null;
    },

    toggleClass: function (element, name, on) {
        if (on) {
            element.classList.add(name);
        } else {
            element.classList.remove(name);
        }
    },

    // collaterate:productDecorationProof: the photos as the server answered, and, for themes built before proofs were
    // per photo, each location's proof in picker order with the first photo's first location at the top.
    decorationProofDetail: function (proofs, decorations) {
        var photos = (proofs && proofs.photos) || [];
        var defaultLocationId = proofs ? proofs.defaultLocationId : null;
        if (!photos.length) {
            return { image: null, proofs: [], locations: [], photos: [], defaultLocationId: defaultLocationId };
        }
        var order = decorations.map(function (decoration) {
            return decoration.locationId;
        });
        var sizeOf = function (locationId) {
            return decorations.find(function (decoration) {
                return decoration.locationId === locationId;
            }) || {};
        };
        var locations = [];
        photos.forEach(function (photo) {
            (photo.locationIds || []).forEach(function (locationId) {
                var size = sizeOf(locationId);
                locations.push({
                    locationId: locationId,
                    photoId: photo.photoId,
                    image: photo.image,
                    photo: photo.photo,
                    resolutionWarning: (photo.resolutionWarnings || []).join(' ') || null,
                    variantMatched: photo.variantMatched !== false,
                    variantLabel: photo.variantMatched === false ? photo.variantLabel || null : null,
                    logoWidthInches: size.imprintWidthInches == null ? null : size.imprintWidthInches,
                    logoHeightInches: size.imprintHeightInches == null ? null : size.imprintHeightInches,
                    proofs: [{ image: photo.image, photo: photo.photo, locationId: locationId }]
                });
            });
        });
        var lead = locations.find(function (location) {
            return location.locationId === (photos[0].locationIds || [])[0];
        }) || locations[0];
        locations.sort(function (a, b) {
            return order.indexOf(a.locationId) - order.indexOf(b.locationId);
        });
        return Object.assign({}, lead, { locations: locations, photos: photos, defaultLocationId: defaultLocationId });
    },

    // Cancelable: false back means a theme is showing the proofs itself.
    announceDecorationProof: function (detail) {
        var bus = window.events;
        if (!bus || !bus.PRODUCT_DECORATION_PROOF) {
            return true;
        }
        if (!detail.updating) {
            bus.trigger(bus.PRODUCT_DECORATION_PROOF);
        } else if (bus.PRODUCT_DECORATION_PROOF_UPDATING) {
            bus.trigger(bus.PRODUCT_DECORATION_PROOF_UPDATING);
        }
        return document.dispatchEvent(new CustomEvent('collaterate:' + bus.PRODUCT_DECORATION_PROOF, {
            detail: detail,
            bubbles: true,
            cancelable: true
        }));
    },

    // The small in-gallery copy takes the shopper to the gallery's slide of it.
    showProofInGallery: function (imageElement) {
        var src = imageElement.getAttribute('src') || imageElement.src;
        var slides = src && document.querySelectorAll ? Array.prototype.slice.call(document.querySelectorAll('img')) : [];
        var slide = slides.find(function (image) {
            return image !== imageElement && (image.getAttribute('src') === src || image.src === src);
        });
        if (slide && slide.scrollIntoView) {
            slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    },

    listenForDecorationChanges: function () {
        var picker = document.getElementById('decorations');
        if (!picker || this.listeningForDecorationChanges) {
            return;
        }
        this.listeningForDecorationChanges = true;
        this.announceDecorationLater = this.announceDecoration.bind(this);
        picker.addEventListener('change', function (event) {
            var target = event && event.target;
            var kind = target && target.classList ? target.classList : {
                contains: function () {
                    return false;
                }
            };
            if (kind.contains('c-decorations-ink-search')) {
                // Searching changes nothing chosen; announcing on its blur would redraw the swatch being clicked.
                return;
            } if (kind.contains('c-decorations-size-range')) {
                this.announceDecorationSoon();
            } else {
                this.announceDecoration();
            }
        }.bind(this));
        picker.addEventListener('input', function (event) {
            var search = event && event.target;
            if (search && search.classList && search.classList.contains('c-decorations-ink-search')) {
                this.renderInkOptions(picker, search.getAttribute('data-location-id'));
            }
        }.bind(this));
        picker.addEventListener('input', function (event) {
            var range = event && event.target;
            if (!range || !range.classList || !range.classList.contains('c-decorations-size-range')) {
                return;
            }
            range.setAttribute('data-chosen', 'true');

            var cell = this.decorationLocationCell(picker, range.getAttribute('data-location-id'));
            var sizing = this.decorationSizingFor(picker, cell.querySelector('.c-decorations-method'));
            if (sizing) {
                var side = this.decorationSideAtStop(sizing, Number(range.value));
                range.setAttribute('data-inches', String(side));

                // Proofs still on their way are for the old size.
                this.dropProofsOnTheirWay();
                this.showProofUpdating(true);
                this.showDecorationSize(range.parentNode, this.decorationSizeAt(sizing, side));
                this.announceDecorationSoon();
            }
        }.bind(this));

        picker.addEventListener('click', function (event) {
            var button = event && event.target && event.target.closest ? event.target.closest('button') : event && event.target;
            var classes = button && button.classList;
            if (!classes) {
                return;
            }
            var cell = button.closest ? button.closest('.c-decorations-location') : null;
            var locationId = button.getAttribute('data-location-id') || (cell && cell.getAttribute('data-location-id'));
            if (classes.contains('c-decorations-ink-change')) {
                this.startInkChange(picker, locationId);
                this.syncDecorationControls();
            } else if (classes.contains('c-decorations-ink-swap')) {
                this.swapInk(picker, locationId, Number(button.getAttribute('data-index')));
                this.syncDecorationControls();
            } else if (classes.contains('c-decorations-ink-reset')) {
                this.resetInks(locationId);
                this.announceDecoration();
            } else if (classes.contains('c-decorations-ink-option')) {
                if (this.pickInk(picker, locationId, button.getAttribute('data-pms'))) {
                    this.announceDecoration();
                }
            }
        }.bind(this));
        picker.addEventListener('click', function (event) {
            var image = event && event.target;
            var cell = picker.querySelector('.c-decorations-proof');
            if (image && image.classList && image.classList.contains('c-decorations-proof-image') && cell
                    && cell.classList.contains('c-decorations-proof--in-gallery')) {
                this.showProofInGallery(image);
            }
        }.bind(this));

        // A logo's picture measures its proportions once it loads; load does not bubble, so this listens on the way down.
        picker.addEventListener('load', function (event) {
            var image = event && event.target;
            var chosen = Array.prototype.slice.call(picker.querySelectorAll('.c-decorations-method')).map(function (select) {
                var logo = this.chosenLogo(picker, select.getAttribute('data-location-id'));
                return logo ? logo.value : null;
            }, this);
            if (image && image.classList && image.classList.contains('c-decorations-logo-image')
                    && chosen.indexOf(image.getAttribute('data-logo-id')) >= 0) {
                this.announceDecorationSoon();
            }
        }.bind(this), true);
    },

    listenForVariantSelection: function () {
        window.stockVariantEvents.listen(this.selectVariant.bind(this));
    },

    selectVariant: function (variantId) {
        // Before the product configuration arrives there is nothing to select from yet; a theme may retry.
        if (!this.model.productConfigData) {
            window.stockVariantEvents.ignore(variantId, 'notReady');
            return;
        }
        var variants = this.model.productConfigData.variants || [];
        var variant = window.stockVariantEvents.resolve(variants, variantId, this.model.getSelectedVariantId());
        if (!variant) {
            return;
        }

        // As the drop-downs do: a theme's registerOnCalcChangedListener hears it before the model changes.
        var configChangeDetails = {
            context: 'selectVariant',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD1',
            fieldType: 'DD',
            previousValue: null,
            newValue: variant.id
        };
        configureEvents.onCalcChanged(configChangeDetails);
        for (var n = 1; n <= 3; n++) {
            var choiceName = variant['attribute' + n + 'Choice'];
            var choice = choiceName && (this.model.getVariantChoices(n) || []).find(function (c) {
                return c.name === choiceName;
            });
            if (choice) {
                var dropDown = document.getElementsByName('VARIANTDD' + n)[0] || document.getElementById('VARIANTDD' + n);
                if (dropDown) {
                    dropDown.value = choice.id;
                }
                this.model.setVariant(n, choice.id);
            }
        }
        this.announceVariant();
        this.model.setUnitStockPriceOverrideAmount(null);
        this.model.setUnitWeightLbsOverrideAmount(null);
        this.updateQuote(configChangeDetails);
    },
    generateUI: function () {
        this.display();
    },
    fetchProductData: function () {
        var self = this;

        return new Promise(function (resolve, reject) {
            var supplierAdmin = USER_TYPE === 'SUPPLIER_ADMIN';

            var storefrontPath = '/api/product-configuration-service/product-configurations/offerings/';
            var adminPath = '/api/product-configuration-service/supplierAdmin/product-configurations/offerings/';

            var offeringPath = supplierAdmin ? adminPath : storefrontPath;
            var offeringsURL = offeringPath + stockGlobals.idWithPrefix;
            var orderItemId = getUrlParm('reorder') || getUrlParm('orderItemId');
            if (orderItemId != null) {
                offeringsURL = offeringsURL + '?orderItemId=' + orderItemId;
            }

            var accessTokenPromise = supplierAdmin ? self.fetchAccessToken() : Promise.resolve();

            accessTokenPromise.then(function (token) {
                $.ajax({
                    url: offeringsURL,
                    method: 'GET',
                    accept: 'application/json',
                    beforeSend: function (xhr) {
                        if (hasValue(token)) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                        }
                    },
                    success: function (productConfigData) {
                        resolve(productConfigData);
                    },
                    error: function () {
                        console.error('Error fetching product data');
                        reject();
                    }
                });
            }).catch(function () {
                reject();
            });
        });
    },
    fetchAccessToken: function () {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/internal/supplierAdmin/adminUsers/jwtFromSession',
                method: 'GET',
                accept: 'application/json',
                success: function (response) {
                    resolve(response.apiToken);
                },
                error: function () {
                    console.error('Error fetching operation groups');
                    reject();
                }
            });
        });
    },
    initialize: function () {
        Promise.all([this.fetchProductData(), this.fetchDecoratedEdit()]).then(function (loaded) {
            controller.decoratedEdit = loaded[1];
            controller.initializeModelAndDisplay(loaded[0]);
        }).catch(function (error) {
            console.error('The product could not be loaded', error);
            growlMessages.showErrorMessage('This product could not be loaded. Refresh the page to try again.');
        });
    },

    // TTI-24082: a decorated cart line opened from the cart's Configure (?orderItemId=) changes that line, or its whole decorated group, in place.
    decoratedEditId: function () {
        var id = getUrlParm('orderItemId');
        return USER_TYPE !== this.USER_TYPES.SUPPLIER_ADMIN && !getUrlParm('reorder') && /^\d+$/.test(String(id || '')) && document.getElementById('decorations') ? Number(id) : null;
    },

    // The line and the rest of its group as they are in the cart; null for any other page, or when the line is not in the shopper's cart.
    fetchDecoratedEdit: function () {
        var id = this.decoratedEditId();
        if (id === null) {
            return Promise.resolve(null);
        }
        return tbg.apiV2({ url: '/projects/v2/cart?siteId=' + encodeURIComponent(stockGlobals.siteId), method: 'GET', suppressDefaultMessages: true, errorHandlers: { default: function () {} }})
            .then(function (response) {
                return controller.decoratedEditOf((response && response.content) || response, id);
            }, function () {
                return null;
            });
    },

    decoratedEditOf: function (cart, id) {
        var items = (cart && cart.items) || [];
        var item = items.filter(function (candidate) {
            return candidate.id === id;
        })[0];
        if (!item || !item.decorations || item.decorations.length === 0) {
            return null;
        }
        var lines = item.decorationGroupId ? items.filter(function (line) {
            return line.decorationGroupId === item.decorationGroupId && !line.cancelled;
        }) : [item];
        var notices = [];
        lines.forEach(function (line) {
            (line.decorationNotices || []).forEach(function (notice) {
                if (notices.indexOf(notice) < 0) {
                    notices.push(notice);
                }
            });
        });
        return {
            orderItemId: id,
            lines: lines.map(function (line) {
                return { orderItemId: line.id, variantId: line.stockVariantId, quantity: line.quantity };
            }),
            decorations: item.decorations,
            notices: notices
        };
    },

    // Sets the picker to the line's decorations: each location's method, logo, size and the shopper's own inks. What the
    // product no longer offers, or a logo since removed, is left off with a notice.
    applyDecoratedEdit: function (edit) {
        var picker = document.getElementById('decorations');
        var notices = edit.notices.slice();
        var wanted = {};
        edit.decorations.forEach(function (decoration) {
            wanted[decoration.locationId] = decoration;
        });
        this.inkChanges = {};
        Array.prototype.slice.call(picker.querySelectorAll('.c-decorations-method')).forEach(function (select) {
            var locationId = select.getAttribute('data-location-id');
            var decoration = wanted[locationId];
            delete wanted[locationId];
            if (!decoration) {
                select.value = '';
                return;
            }
            var where = decoration.locationName || 'A location';
            if (!select.querySelector('option[value="' + decoration.decorationId + '"]')) {
                select.value = '';
                notices.push(where + ' is no longer offered with ' + (decoration.decorationName || 'its method') + ', so it was left off.');
                return;
            }
            select.value = String(decoration.decorationId);
            var cell = this.decorationLocationCell(picker, locationId);
            var logo = null;
            if (decoration.brandedLogoFileId != null) {
                logo = (cell && cell.querySelector('input[name="DECORATIONLOGO' + locationId + '"][value="' + decoration.brandedLogoFileId + '"]'))
                    || picker.querySelector('input[name="DECORATIONLOGO"][value="' + decoration.brandedLogoFileId + '"]');
                if (logo) {
                    logo.checked = true;
                } else {
                    notices.push('The logo ' + (decoration.brandedLogoName ? '"' + decoration.brandedLogoName + '" ' : '') + 'at ' + where + ' has been removed. Choose another.');
                }
            }
            var range = cell && cell.querySelector('.c-decorations-size-range');
            if (range && decoration.imprintWidthInches && decoration.imprintHeightInches) {
                range.setAttribute('data-chosen', 'true');
                range.setAttribute('data-inches', String(Math.max(Number(decoration.imprintWidthInches), Number(decoration.imprintHeightInches))));
            }
            if (logo && decoration.inksChosen && decoration.inkColors && decoration.inkColors.length > 0) {
                this.inkChanges[locationId] = {
                    logoId: logo.value,
                    inks: decoration.inkColors.map(function (ink) {
                        return { pms: ink.pms, name: ink.name, hex: ink.hex, enclosed: ink.enclosed };
                    })
                };
            }
        }, this);
        Object.keys(wanted).forEach(function (locationId) {
            notices.push((wanted[locationId].locationName || 'A location') + ' is no longer offered, so it was left off.');
        });
        var shown = picker.querySelector('.c-decorations-edit-notices');
        if (shown) {
            shown.parentNode.removeChild(shown);
        }
        if (notices.length > 0) {
            var list = document.createElement('ul');
            list.className = 'c-decorations-edit-notices';
            list.setAttribute('role', 'status');
            notices.forEach(function (notice) {
                var entry = document.createElement('li');
                entry.textContent = notice;
                list.appendChild(entry);
            });
            picker.insertBefore(list, picker.firstChild);
        }
        return notices;
    },

    // The line's variant and quantity, or every line of its group in the grid. The first line's variant is the page's chosen one
    // either way, so the photos and the mockup start on its color.
    applyDecoratedEditQuantities: function (edit) {
        var variants = this.model.productConfigData.variants || [];
        var variantOf = function (id) {
            return variants.filter(function (variant) {
                return variant.id === id;
            })[0];
        };
        var first = variantOf(edit.lines[0].variantId);
        if (first) {
            for (var n = 1; n <= 3; n++) {
                var name = first['attribute' + n + 'Choice'];
                var choice = name && (this.model.getVariantChoices(n) || []).filter(function (c) {
                    return c.name === name;
                })[0];
                if (choice) {
                    this.model.setVariant(n, choice.id);
                }
            }
        }
        if (this.isQuantityMatrix()) {
            this.matrixQuantities = {};
            edit.lines.forEach(function (line) {
                if (variantOf(line.variantId)) {
                    this.matrixQuantities[line.variantId] = line.quantity;
                }
            }, this);
            if (first) {
                this.model.getQuantityMatrix().otherNums.forEach(function (num) {
                    this.matrixChoices[num] = first['attribute' + num + 'Choice'];
                }, this);
            }
            return;
        }
        this.model.qty = edit.lines[0].quantity;
    },

    // "Update cart": the line, or each size of its group, sent as the product page adds it; the cart then shows them in place.
    updateDecoratedItems: function () {
        var items = this.isQuantityMatrix() ? this.matrixItems() : [this.addOrderItemRequestData()];
        return tbg.apiV2({
            url: '/projects/v2/cart/decoratedItems/' + this.decoratedEdit.orderItemId,
            method: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({ items: items })
        }).then(function () {
            gotoURL(hasValue(configuratorGlobals.nextStepUrl) ? configuratorGlobals.nextStepUrl : '/order/cart');
        });
    },
    onLogin: function () {
        controller.getQuote(true, function () {
            var configChangeDetails = {
                context: 'onLogin',
                category: confUtil.LOGIN
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
    },
    getOfferingName: function () {
        var cstockoffering = configureglobals.cstockoffering;
        if (cstockoffering == null) {
            return '';
        }
        return cstockoffering.name;
    },
    setCQuoteData: function (object) {
        configureglobals.set('cquotedata', object);
        this.validation = new JobQuoteValidation(object.validation);
        dynamic.setDivIdContent('validationMessagesDiv', this.validation.generateGlobalMessages());
    },
    setCQuote: function (cquote) {
        configureglobals.set('cquote', cquote);

        // The grid prices every line itself and announces the total on PRODUCT_QUANTITY_GRID_QUOTED; this quote is one variant's.
        if (controller.isQuantityMatrix()) {
            controller.scheduleMatrixQuote();
            return;
        }

        if (configureglobals.cquote) {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, configureglobals.cquote);
        } else {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, {});
        }

        if (cquote == null) {
            dynamic.setDivIdContent('productQuotePrices', '--');
        } else {
            var content = '';
            var table = new JDTable({
                cssClass: 'quote'
            });
            table.addRow([
                {
                    text: (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0 ? 'Original ' : 'Your ') + 'Price',
                    tag: 'th',
                    scope: 'row'
                },
                {
                    text: '<span class="lineItemPrice">$' + cquote.jobTotalPriceDisplay + '</span>'
                }
            ], {
                cssClass: 'productPrice'
            });
            if (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0) {
                if (cquote.offeringDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + cquote.offeringDiscountPercent + '% Savings',
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobOfferingDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount'
                    });
                }
                if (cquote.userDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + strWeb(cquote.userDiscountName),
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobUserDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount userDiscount'
                    });
                }
                table.addRow([
                    {
                        text: 'Your Price',
                        tag: 'th',
                        scope: 'row'
                    },
                    {
                        text: '<span class="lineItemPrice">$' + cquote.totalPriceDisplay + '</span>'
                    }
                ], {
                    cssClass: 'productPrice discounted'
                });
            }
            content += table.generate();
            content += controller.decorationChargesHtml(cquote.decorationCharges, {
                total: cquote.totalPrice,
                pieces: cquote.quantity || (controller.model && controller.model.qty)
            });
            dynamic.setDivIdContent('productQuotePrices', content);
        }
    },
    display: function () {
        if (this.isQuantityMatrix()) {
            this.generateQuantityMatrix();
            this.generateAdditionalFields();
            this.generateAvailableInventory();
            return;
        }

        var variantTitleCount = this.model.getVariantTitleCount();

        if (variantTitleCount == 0) {
            controller.generateSingleInventory();
        }
        if (variantTitleCount > 0) {
            controller.generateVariantChoice1();
        }
        if (variantTitleCount > 1) {
            controller.generateVariantChoice2();
        }
        if (variantTitleCount > 2) {
            controller.generateVariantChoice3();
        }
        this.generateQuantityDiv();
        this.generateUnitStockPriceOverrideAmountDiv();
        this.generateUnitWeightLbsOverrideAmountDiv();

        this.generateAdditionalFields();
        this.generateAvailableInventory();
    },
    efVals: {},
    ef: null,
    efFocus: function (fieldName, containerDivId, buttonDivId) {
        this.ef = fieldName;
        this.efVals[fieldName] = getFormItemValue(fieldName, document);

        // var cssClass = dynamic.getClass(containerDivId);
        dynamic.addClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, forms.button('Update', {
            cssClass: 'secondary config'
        }));
    },

    // aria-disabled rather than disabled, so the button keeps its place in the tab order while the price updates;
    // addToCart refuses it until then.
    continueEnabled: true,
    setContinueButtonEnabled: function (enabled) {
        controller.continueEnabled = enabled;
        $('.addToCart').prop('disabled', false).attr('aria-disabled', enabled ? null : 'true');
    },
    efBlur: function (fieldName, containerDivId, buttonDivId, valueUpdatedCallbackFn) {
        var previousValue = this.efVals[fieldName];
        dynamic.removeClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, '');
        var newValue = getFormItemValue(fieldName, document);

        if (typeof valueUpdatedCallbackFn === 'function') {
            valueUpdatedCallbackFn(newValue);
        }

        if (previousValue != newValue || fieldName == 'QUANTITYEF') {
            var configChangeDetails = {
                context: 'efBlur',
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: previousValue,
                newValue: newValue
            };
            configureEvents.onCalcChanged(configChangeDetails);
            controller.getQuote(false, function () {
                controller.generateUI(configChangeDetails, { list: [] });
                configureEvents.onQuoteUpdated(configChangeDetails);
            }, function () { // on failure reset to the previous value.
                setFieldValue(fieldName, previousValue, document);
            });
            this.ef = null;
        }
    },
    setOptionDiv: function (divId, content) {
        if (content == '') {
            dynamic.setClass(divId, 'optionWrapperEmpty');
        } else {
            dynamic.setClass(divId, 'optionWrapperOn');
        }
        dynamic.setDivIdContent(divId, content);
    },
    generateSingleInventory: function () {
        var variants = this.model.getVariants();
        variant = variants[0];
        var content = '';

        // content += '<label class="config">SKU</label>';
        // content += variant.skuSuffix;
        controller.setOptionDiv('variantDiv1', content);
    },
    generateVariantChoice1: function () {
        var fieldName = 'VARIANTDD1';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);

        var cvariantchoices = this.model.getVariantChoices(1);
        var selectedchoice = this.model.variant1Choice;

        var help = '';
        content += '<label class="config">' + help + this.model.getStockAttributeTitle(1) + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice1()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv1', content);
    },
    setVariantChoice1: function () {
        var newValue = getDropDownSelectedValue('VARIANTDD1', document);
        var configChangeDetails = {
            context: 'setVariantChoice1',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD1',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setVariant(1, newValue);
        this.model.keepSoldChoices();
        this.announceVariant();
        this.model.setUnitStockPriceOverrideAmount(null);
        this.model.setUnitWeightLbsOverrideAmount(null);

        this.updateQuote(configChangeDetails);
    },
    generateVariantChoice2: function () {
        var fieldName = 'VARIANTDD2';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);

        var cvariantchoices = this.model.getVariantChoices(2);
        var selectedchoice = this.model.variant2Choice;

        var help = '';

        content += '<label class="config">' + help + this.model.getStockAttributeTitle(2) + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice2()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv2', content);
        this.markUnsoldChoices(2);
    },
    setVariantChoice2: function () {
        var newValue = getDropDownSelectedValue('VARIANTDD2', document);
        var configChangeDetails = {
            context: 'setVariantChoice2',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD2',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setVariant(2, newValue);
        this.model.keepSoldChoices();
        this.announceVariant();
        this.model.setUnitStockPriceOverrideAmount(null);
        this.model.setUnitWeightLbsOverrideAmount(null);

        this.updateQuote(configChangeDetails);
    },
    generateVariantChoice3: function () {
        var fieldName = 'VARIANTDD3';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);

        var cvariantchoices = this.model.getVariantChoices(3);
        var selectedchoice = this.model.variant3Choice;
        var help = '';

        content += '<label class="config">' + help + this.model.getStockAttributeTitle(3) + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice3()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv3', content);
        this.markUnsoldChoices(3);
    },
    setVariantChoice3: function () {
        var newValue = getDropDownSelectedValue('VARIANTDD3', document);
        var configChangeDetails = {
            context: 'setVariantChoice3',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD3',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setVariant(3, newValue);
        this.announceVariant();
        this.model.setUnitStockPriceOverrideAmount(null);
        this.model.setUnitWeightLbsOverrideAmount(null);

        this.updateQuote(configChangeDetails);
    },

    // A choice the earlier ones leave unsold stays listed, disabled, saying why.
    markUnsoldChoices: function (variantNum) {
        var dropDown = document.getElementsByName('VARIANTDD' + variantNum)[0];
        if (!dropDown || !dropDown.options) {
            return;
        }
        var choices = this.model.getVariantChoices(variantNum) || [];
        var note = this.model.unsoldChoiceNote(variantNum);
        Array.prototype.slice.call(dropDown.options).forEach(function (option) {
            var choice = choices.find(function (c) {
                return String(c.id) === option.value;
            });
            if (choice && !this.model.isChoiceSold(variantNum, choice.name)) {
                option.disabled = true;
                option.textContent = choice.name + ' \u2014 ' + note;
            }
        }, this);
    },
    generateQuantityDiv: function () {
        var fieldName = 'QUANTITYEF';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
        var help = '';

        var soldascontent = this.model.getSoldAsContent();
        content += help + '<label class="config">' + this.model.getQuantityLabel() + soldascontent + '</label>';
        content += forms.ef(fieldName, this.model.qty, {
            size: 5,
            cssClass: 'configField' + (error ? ' error' : ''),
            onfocus: 'controller.efFocus(\'' + fieldName + '\',\'quantityDiv\', \'quantityFocus\')',
            onblur: 'controller.setQuantity()'
        });
        content += '<span id="quantityFocus" class="changeFocusButton"><!-- dynamic --></span>';
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('quantityDiv', content);
    },
    setQuantity: function () {
        var enteredQuantity = getFormItemValue('QUANTITYEF', document);
        var isEmpty = !enteredQuantity || !enteredQuantity.trim().length;

        if (this.validate(enteredQuantity)) {
            controller.efBlur('QUANTITYEF', 'quantityDiv', 'quantityFocus', function (newValue) {
                controller.model.qty = +newValue;
            });
        } else {
            // Disable "Continue" button for invalid quantity
            controller.setContinueButtonEnabled(false);

            dynamic.setDivIdContent('validationMessagesDiv', controller.validation.generateGlobalMessages());

            if (isEmpty) {
                controller.model.qty = undefined;
            } else if (enteredQuantity <= 0) {
                controller.model.qty = 0;
            } else if (!isNaN(enteredQuantity) && enteredQuantity <= JAVA_INTEGER_MAX_VALUE) {
                // Under the minimum: the field keeps what was typed beside its message, rather than the last good quantity.
                controller.model.qty = +enteredQuantity;
            }

            controller.setCQuote(null);
            this.generateQuantityDiv();

            var configChangeDetails = {
                context: 'setQuantity',
                category: confUtil.FIELD_CHANGE,
                fieldName: 'QUANTITYEF',
                fieldType: 'EF',
                previousValue: null,
                newValue: null
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        }
    },
    generateUnitStockPriceOverrideAmountDiv: function () {
        if (dynamic.divIdExists('unitStockPriceOverrideAmountDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'UNIT_STOCK_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            content += help + '<label class="config">Unit Price</label>';
            content += forms.ef(fieldName, this.model.unitStockPriceOverrideAmount, {
                size: 5,
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'controller.efFocus(\'' + fieldName + '\',\'unitStockPriceOverrideAmountDiv\', \'unitStockPriceOverrideAmountFocus\')',
                onblur: 'controller.setUnitStockPriceOverrideAmount()'
            });
            content += '<span id="unitStockPriceOverrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            controller.setOptionDiv('unitStockPriceOverrideAmountDiv', content);
        }
    },
    hasInvalidOverrideAmount: function (fieldName, message, regenerateDiv) {
        var enteredAmount = getFormItemValue(fieldName, document);
        var cleanedAmount = enteredAmount ? enteredAmount.replace(/,/g, '') : enteredAmount;

        if (cleanedAmount && isNaN(+cleanedAmount)) {
            var cquotedata = configureglobals.cquotedata;
            cquotedata.clearFieldErrors(fieldName);
            cquotedata.clearGlobalErrors();
            cquotedata.addFieldError(fieldName, message);
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            dynamic.setDivIdContent('validationMessagesDiv', controller.validation.generateGlobalMessages());
            this.setCQuote(null);
            regenerateDiv();
            return true;
        }
        return false;
    },
    setUnitStockPriceOverrideAmount: function () {
        if (this.hasInvalidOverrideAmount('UNIT_STOCK_PRICE_OVERRIDE_AMOUNT_EF', 'Unit Price must be a dollar amount.', controller.generateUnitStockPriceOverrideAmountDiv.bind(controller))) {
            return;
        }
        controller.efBlur('UNIT_STOCK_PRICE_OVERRIDE_AMOUNT_EF', 'unitStockPriceOverrideAmountDiv', 'unitStockPriceOverrideAmountFocus', function (newValue) {
            controller.model.setUnitStockPriceOverrideAmount(+newValue.replace(/,/g, ''));
        });
    },
    generateUnitWeightLbsOverrideAmountDiv: function () {
        if (dynamic.divIdExists('unitWeightLbsOverrideAmountDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'UNIT_WEIGHT_LBS_OVERRIDE_AMOUNT_EF';
            var content = '';
            var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            content += help + '<label class="config">Unit Weight (lbs)</label>';
            content += forms.ef(fieldName, this.model.unitWeightLbsOverrideAmount, {
                size: 5,
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'controller.efFocus(\'' + fieldName + '\',\'unitWeightLbsOverrideAmountDiv\', \'unitWeightLbsOverrideAmountFocus\')',
                onblur: 'controller.setUnitWeightLbsOverrideAmount()'
            });
            content += '<span id="unitWeightLbsOverrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            controller.setOptionDiv('unitWeightLbsOverrideAmountDiv', content);
        }
    },
    setUnitWeightLbsOverrideAmount: function () {
        if (this.hasInvalidOverrideAmount('UNIT_WEIGHT_LBS_OVERRIDE_AMOUNT_EF', 'Unit Weight must be a number.', controller.generateUnitWeightLbsOverrideAmountDiv.bind(controller))) {
            return;
        }
        controller.efBlur('UNIT_WEIGHT_LBS_OVERRIDE_AMOUNT_EF', 'unitWeightLbsOverrideAmountDiv', 'unitWeightLbsOverrideAmountFocus', function (newValue) {
            controller.model.setUnitWeightLbsOverrideAmount(+newValue.replace(/,/g, ''));
        });
    },
    getQuoteURL: function () {
        if (stockGlobals && stockGlobals.SALES_ESTIMATE_MODE === true) {
            return this.QUOTE_URLS.CUSTOM;
        }

        return USER_TYPE === this.USER_TYPES.SUPPLIER_ADMIN
            ? this.QUOTE_URLS.EXTENDED
            : this.QUOTE_URLS.DEFAULT;
    },
    validate: function (enteredQuantity) {
        var quoteData = configureglobals.cquotedata;
        if (!quoteData) {
            return true;
        }

        var valid = this.validateQuantity(enteredQuantity);

        quoteData.clearGlobalErrors();
        if (!valid) {
            quoteData.addGlobalError('A quote was not completed.  Please make adjustments.');
        }

        return valid;
    },
    lastRequestId: 0,
    getQuote: function (isLogin, onQuoteUpdatedFunction, onQuoteUpdateFailedFunction) {
        dynamic.setDivIdContent('jobQuote', '--');

        // Disable "Continue" button until quote successfully generated
        controller.setContinueButtonEnabled(false);
        controller.quoteProblem = null;

        var requestId = ++this.lastRequestId;
        var self = this;
        tbg.apiV2({
            url: controller.getQuoteURL(),
            urlPrefix: '',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(this.model.generateQuoteRequestData()),
            suppressDefaultMessages: true,
            errorHandlers: {
                417: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    controller.quoteProblem = controller.firstErrorDetail(response) || 'Change the highlighted choices to get a price.';
                    controller.setCQuoteData(new StockQuoteDataAdapter(controller.model, response));
                    controller.setCQuote(null);
                    controller.generateUI();
                    controller.onStockQuoteComplete(null);

                    if (typeof onQuoteUpdatedFunction === 'function') {
                        onQuoteUpdatedFunction();
                    }
                },
                default: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    controller.quoteProblem = controller.firstErrorDetail(response) || 'The price could not be calculated. Try again, or change your choices.';
                    controller.setCQuote(null);
                    controller.generateUI();
                    controller.onStockQuoteComplete(null);

                    if (typeof onQuoteUpdateFailedFunction === 'function') {
                        onQuoteUpdateFailedFunction();
                    }
                    configureEvents.onQuoteUpdated(null);

                    var errors = response && response.errors;
                    if (errors && errors.length) {
                        errors.forEach(function (e) {
                            growlMessages.showErrorMessage(e.detail);
                        });
                    } else {
                        growlMessages.showErrorMessage('An error occurred while getting a quote. Please try again.');
                    }
                }
            }
        }).then(function (quoteResponse) {
            if (!quoteResponse || requestId !== controller.lastRequestId) {
                return;
            }

            var quote = quoteResponse.content;
            controller.initUnitWeightAndPrice(quote);
            controller.setCQuote(new StockQuoteAdapter(controller.model, quote));
            controller.setCQuoteData(new StockQuoteDataAdapter(controller.model, quote));

            self.showValidationMessages(quoteResponse, !self.parentController);

            controller.onStockQuoteComplete(configureglobals.cquote != null);
            if (controller.ef != null) {
                focusOn(controller.ef, document);
                selectAll(controller.ef, document);
            }
            controller.quoteProblem = null;
            if (typeof onQuoteUpdatedFunction === 'function') {
                onQuoteUpdatedFunction();
            }
            controller.setContinueButtonEnabled(true);
        });
    },
    // Why there is no price to add to the cart with, once a quote has come back without one.
    quoteProblem: null,
    firstErrorDetail: function (response) {
        var errors = response && response.errors;
        return errors && errors.length && errors[0] && errors[0].detail ? errors[0].detail : null;
    },
    initUnitWeightAndPrice: function (quote) {
        if (quote.unitStockPriceOverrideAmount) {
            this.model.unitStockPriceOverrideAmount = quote.unitStockPriceOverrideAmount;
        }
        if (quote.unitWeightLbsOverrideAmount) {
            this.model.unitWeightLbsOverrideAmount = quote.unitWeightLbsOverrideAmount;
        }
    },
    showValidationMessages: function (quoteResponse, showAsGrowlMessages) {
        if (showAsGrowlMessages) {
            growlMessages.showAllRestMessages(quoteResponse);
        } else {
            var quoteWarningMessages = this.validation.buildWarningList(quoteResponse);

            for (var i = 0; i < quoteWarningMessages.length; i++) {
                this.validation.cvalidation.globalInfoMessages.push({ value: quoteWarningMessages[i] });
                this.validation.cvalidation.hasGlobalInfoMessages = true;
            }

            var content = this.validation.generateGlobalMessages();
            dynamic.setDivIdContent('validationMessagesDiv', content);
        }
    },
    parentController: null,
    onStockQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.stockQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },

    generateAdditionalFields: function () {
        var quoteData = configureglobals.cquotedata;
        var metadata = quoteData.metadata;
        var additionalFields = quoteData.additionalFields;
        var content = '';

        for (var i = 0, ni = metadata ? metadata.length : 0; i < ni; i++) {
            var metadataItem = metadata[i];
            var additionalFieldValue = '';
            if (additionalFields != null) {
                if (additionalFields[metadataItem.name]) {
                    additionalFieldValue = additionalFields[metadataItem.name];
                }
            }
            var datatype = metadataItem.dataType;
            content += '<div id="ai' + metadataItem.id + '" class="optionWrapperOn' + (metadataItem.required ? ' required' : '') + '">';
            var fieldName = 'ADDITIONALFIELD' + i;
            if (datatype === 'EF') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, strWeb(additionalFieldValue), {
                    cssClass: 'additionalText' + (metadataItem.required ? ' required' : ''),
                    onblur: 'controller.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype === 'TA') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ta(fieldName, strWeb(additionalFieldValue), {
                    rows: 4,
                    cssClass: 'additionalTA' + (metadataItem.required ? ' required' : ''),
                    onblur: 'controller.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype === 'DD') {
                var ddValues = metadataItem.preDefinedTextValues;
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.dd(fieldName, ddValues.list, {
                    id: additionalFieldValue
                }, {
                    cssClass: 'configSelect additional' + (metadataItem.required ? ' required' : ''),
                    onblur: 'controller.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype == 'CB') {
                content += tags.div(forms.cb(fieldName, metadataItem.name, additionalFieldValue, {
                    onchange: 'controller.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')',
                    cssClass: 'additionalCB'
                }));
            } else if (datatype === 'DP') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, normalizeDateValue(additionalFieldValue), {
                    cssClass: 'additionalText' + (metadataItem.required ? ' required' : ''),
                    type: 'date',
                    autocomplete: 'nope',
                    onchange: 'controller.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            }

            content += '</div>';
        }
        dynamic.setDivIdContent('additionalProductFields', content);
    },

    setAdditionalField: function (question, id) {
        var cquotedata = configureglobals.cquotedata;
        var formItem = getFormItem('ADDITIONALFIELD' + id, document);
        if (formItem.type === 'checkbox') {
            cquotedata.setAdditionalField(question, formItem.checked);
        } else {
            cquotedata.setAdditionalField(question, formItem.value);
        }

        // For custom quote (Sales Estimate) context only, trigger a quote update on field change.
        // For normal storefront order entry, metadata is submitted with addToCart() — no recalc needed as metadata fields do not affect pricing.
        if (stockGlobals && stockGlobals.SALES_ESTIMATE_MODE === true) {
            var configChangeDetails = {
                context: 'setAdditionalField',
                category: confUtil.INDEXED_FIELD_CHANGE,
                fieldIndex: id,
                fieldName: 'ADDITIONALFIELD',
                fieldType: 'EF',
                previousValue: null,
                newValue: null
            };

            configureEvents.onCalcChanged(configChangeDetails);
            controller.updateQuote(configChangeDetails);
        }
    },

    addToCart: function () {
        if (this.isProcessing) {
            return;
        }
        if (!controller.continueEnabled) {
            var problem = controller.isQuantityMatrix() ? null : controller.quantityProblem(getFormItemValue('QUANTITYEF', document));
            growlMessages.showErrorMessage(problem || controller.quoteProblem || 'The price is still updating. Try again in a moment.');
            return;
        }
        var validator = new Validator();
        controller.validateAdditionalFields(validator);

        if (validator.isValid() && controller.decoratedEdit) {
            var editProblem = controller.isQuantityMatrix() ? controller.matrixProblem() : null;
            if (editProblem) {
                growlMessages.showErrorMessage(editProblem);
                return;
            }
            this.isProcessing = true;
            controller.updateDecoratedItems()
                .catch(function (error) {
                    console.error('An error occurred while updating the cart', error);
                    this.isProcessing = false;
                }.bind(this));
        } else if (validator.isValid() && controller.isQuantityMatrix()) {
            var problem = controller.matrixProblem();
            if (problem) {
                growlMessages.showErrorMessage(problem);
                return;
            }
            this.isProcessing = true;
            controller.addMatrixToCart()
                .catch(function (error) {
                    console.error('An error occurred while adding to cart', error);
                }).then(function () {
                    this.isProcessing = false;
                }.bind(this));
        } else if (validator.isValid()) {
            this.isProcessing = true;
            controller.addItemToCart()
                .catch(function (error) {
                    console.error('An error occurred while adding to cart', error);
                    this.isProcessing = false;
                });
        }
    }.bind(this),

    addItemToCart: function () {
        return tbg.apiV2({
            url: '/projects/v2/cart/addItem',
            method: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(controller.addOrderItemRequestData())
        }).then(function () {
            controller.gotoNextStep();
        }).catch(function (errorResponse) {
            console.log('An error occurred while adding product to the cart. ' + JSON.stringify(errorResponse));
        });
    },

    addOrderItemRequestData: function () {
        var quoteData = configureglobals.cquotedata;
        var decoration = controller.decorationChoice();

        return {
            userId: controller.getUserId(),
            clientKey: controller.getUserId() == null ? controller.getCookieByName('anonymous-user-cart') : null,
            jobName: controller.model.getOfferingName(),
            quantity: quoteData.quantity,
            productInfoId: controller.getProductInfo(quoteData),
            metaData: quoteData.additionalFields,
            quoteDataOverrides: quoteData.jobSpecOverrides,
            decorations: decoration ? decoration.decorations : null,
            brandedLogoFileId: decoration ? decoration.brandedLogoFileId : null
        };
    },

    getProductInfo: function (quoteData) {
        return {
            siteId: stockGlobals.siteId,
            idWithPrefix: stockGlobals.idWithPrefix,
            variantId: quoteData.variantId
        };
    },

    getCookieByName: function (name) {
        var match = document.cookie
            .match(new RegExp('(^|;\\s*)' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }

        return null;
    },

    getUserId: function () {
        if (globalpageglobals.cuser != null) {
            return globalpageglobals.cuser.id;
        }
        return null;
    },

    validateAdditionalFields: function (validator) {
        var quoteData = configureglobals.cquotedata;
        var quoteValidation = controller.validation;
        quoteValidation.setValidationErrorReasons(validator);

        validator.addItem(new CustomValidateItem(null, function () {
            var metadata = quoteData.metadata;
            this.reason = '';
            if (metadata != null) {
                for (var i = 0; i < metadata.length; i++) {
                    var metadataItem = metadata[i];
                    if (metadataItem.required) {
                        var datatype = metadataItem.dataType;
                        if (datatype === 'EF' || datatype === 'DD' || datatype === 'TA' || datatype === 'DP') {
                            if (!itemHasValue(getFormItem('ADDITIONALFIELD' + i, document))) {
                                this.reason += '"' + metadataItem.name + '"' + ' is required\n';
                            }
                        } else {
                            if (!isChecked('ADDITIONALFIELD' + i, document)) {
                                this.reason += '"' + metadataItem.name + '"' + ' must be checked\n';
                            }
                        }
                    }
                }
            }
            return this.reason === '';
        }));
    },

    /**
     * Enter a quantity for every size at once and add them together (TTI-24064). A site setting, and
     * only on a product with a Size attribute; custom quotes, admin requotes and editing a cart item keep
     * the one-variant form, because each of those works on a single item.
     */
    isQuantityMatrix: function () {
        // A decorated group being changed shows in the grid, as it was ordered, even where the site has turned the grid off.
        var editing = this.decoratedEdit;
        var gridOn = stockGlobals.quantityMatrix === true || Boolean(editing && editing.lines.length > 1);
        if (!gridOn
            || USER_TYPE === this.USER_TYPES.SUPPLIER_ADMIN
            || stockGlobals.SALES_ESTIMATE_MODE === true
            || getUrlParm('reorder')
            || (getUrlParm('orderItemId') && !editing)) {
            return false;
        }
        if (this.model.getSizeAttributeNumber() === null) {
            this.warnNoSizeAttribute();
            return false;
        }
        return true;
    },
    warnNoSizeAttribute: function () {
        if (this.warnedNoSizeAttribute) {
            return;
        }
        this.warnedNoSizeAttribute = true;
        console.warn('Quantity grid: the site setting is on, but "' + this.model.getOfferingName() + '" has no stock attribute titled'
            + ' "Size" or "Sizes" (any case, surrounding spaces ignored), so it shows the one-size form.');
    },
    matrixQuantities: {},
    matrixChoices: {},

    // The chosen value of each non-size attribute, defaulting to its first; together they name a row.
    matrixRowLabel: function (matrix) {
        return matrix.otherNums.map(function (num) {
            var names = this.model.getVariantChoices(num).map(function (choice) {
                return choice.name;
            });
            if (names.indexOf(this.matrixChoices[num]) < 0) {
                this.matrixChoices[num] = names[0];
            }
            return this.matrixChoices[num];
        }, this).join(' / ');
    },

    /**
     * The non-size attributes as drop-downs, then the chosen row's sizes as boxes that wrap, so it fits
     * any column. Quantities are kept per variant, so switching Color keeps what was entered for the
     * others, and the summary lists every row with a quantity.
     */
    /**
     * The grid's default styles, first in the head so any theme stylesheet overrides them. They are here rather than in
     * global.css because themes whose templates use no_core_css never load global.css.
     */
    quantityGridDefaults: [
        '.c-quantity-grid-sizes { display: flex; flex-wrap: wrap; gap: 8px; margin: 4px 0 12px 0; }',
        '.c-quantity-grid-size { display: flex; flex-direction: column; align-items: center; width: 56px; margin: 0; }',
        '.c-quantity-grid-size-name { font-size: 12px; margin-bottom: 2px; white-space: nowrap; }',
        '.c-quantity-grid-size .c-quantity-grid-size-input { width: 100%; min-width: 0; padding: 4px; box-sizing: border-box; text-align: center; }',
        '.c-quantity-grid-size-none { line-height: 32px; }',
        '.c-quantity-grid-size--unavailable { opacity: 0.5; }',
        '.c-quantity-grid-summary-list { list-style: none; margin: 0 0 8px 0; padding: 0; font-size: 13px; }',
        '.c-quantity-grid-summary-row { margin: 2px 0; }',
        '.c-quantity-grid-total { margin: 4px 0 8px 0; }'
    ].join('\n'),
    addQuantityGridDefaults: function () {
        if (document.getElementById('quantityGridDefaults')) {
            return;
        }
        var style = document.createElement('style');
        style.id = 'quantityGridDefaults';
        style.textContent = this.quantityGridDefaults;
        document.head.insertBefore(style, document.head.firstChild);
    },
    generateQuantityMatrix: function () {
        this.addQuantityGridDefaults();
        var matrix = this.model.getQuantityMatrix();
        var rowLabel = this.matrixRowLabel(matrix);
        var quantities = this.matrixQuantities;
        var content = '<div class="c-quantity-grid">';

        matrix.otherNums.forEach(function (num) {
            var fieldName = 'MATRIXDD' + num;
            content += '<label class="config" for="' + fieldName + '">' + strWeb(this.model.getStockAttributeTitle(num)) + '</label>';
            content += '<select class="configSelect c-quantity-grid-choice" id="' + fieldName + '" name="' + fieldName + '" onchange="controller.setMatrixChoice(' + num + ', this.value)">';
            this.model.getVariantChoices(num).forEach(function (choice) {
                content += '<option value="' + strWeb(choice.name) + '"' + (choice.name === this.matrixChoices[num] ? ' selected' : '') + '>' + strWeb(choice.name) + '</option>';
            }, this);
            content += '</select>';
        }, this);

        content += '<label class="config">' + this.model.getQuantityLabel() + ' by size' + this.model.getSoldAsContent() + '</label>';
        content += '<div class="c-quantity-grid-sizes">';
        matrix.sizes.forEach(function (size) {
            var variant = matrix.variantAt(rowLabel, size);
            if (!variant) {
                content += '<div class="c-quantity-grid-size c-quantity-grid-size--unavailable">'
                    + '<span class="c-quantity-grid-size-name">' + strWeb(size) + '</span>'
                    + '<span class="c-quantity-grid-size-none" aria-label="' + strWeb(size) + ' not available">&ndash;</span></div>';
                return;
            }
            content += '<label class="c-quantity-grid-size">'
                + '<span class="c-quantity-grid-size-name">' + strWeb(size) + '</span>'
                + '<input type="number" min="0" step="1" inputmode="numeric" class="configField c-quantity-grid-size-input"'
                + ' name="MATRIXQTY' + variant.id + '" aria-label="' + strWeb((rowLabel ? rowLabel + ' ' : '') + size) + ' quantity"'
                + ' value="' + (quantities[variant.id] || '') + '"'
                + ' onchange="controller.setMatrixQuantity(' + variant.id + ', this.value)"></label>';
        });
        content += '</div>';
        content += '<div id="quantityGridSummary" class="c-quantity-grid-summary">' + this.matrixSummaryContent() + '</div>';
        content += '<div id="quantityGridTotal" class="c-quantity-grid-total">' + this.matrixTotalContent() + '</div>';
        content += '</div>';

        controller.setOptionDiv('variantDiv1', content);
        controller.setOptionDiv('variantDiv2', '');
        controller.setOptionDiv('variantDiv3', '');
        controller.setOptionDiv('quantityDiv', '');
    },
    setMatrixChoice: function (num, value) {
        this.matrixChoices[num] = value;
        this.generateQuantityMatrix();
        this.matrixRowChanged();
    },

    // The grid's color row the shopper is on: the first variant sold in it.
    matrixRowVariant: function () {
        var matrix = this.model.getQuantityMatrix();
        var row = this.matrixRowLabel(matrix);
        return matrix.sizes.map(function (size) {
            return matrix.variantAt(row, size);
        }).filter(Boolean)[0] || null;
    },

    // The photos and the mockup follow the row, as they follow the chosen variant on a page without the grid.
    proofVariantId: function () {
        if (this.isQuantityMatrix()) {
            var variant = this.matrixRowVariant();
            return variant ? variant.id : null;
        }
        return this.model.getSelectedVariantId();
    },

    matrixRowChanged: function () {
        var variantId = this.proofVariantId();
        if (variantId && window.stockVariantEvents) {
            window.stockVariantEvents.announce(variantId);
        }
        if (this.syncDecorationControls()) {
            this.announceDecoration();
            return;
        }
        var choice = this.decorationChoice();
        if (choice && this.proofsAsked) {
            this.showDecorationProof(choice);
        }
    },

    // Brings a row from the summary back into the drop-downs to change it.
    showMatrixRow: function (index) {
        var matrix = this.model.getQuantityMatrix();
        var row = matrix.rows[index];
        var variant = matrix.sizes.map(function (size) {
            return matrix.variantAt(row, size);
        }).filter(Boolean)[0];
        if (!variant) {
            return;
        }
        matrix.otherNums.forEach(function (num) {
            this.matrixChoices[num] = variant['attribute' + num + 'Choice'];
        }, this);
        this.generateQuantityMatrix();
        this.matrixRowChanged();
    },

    /** Every row with a quantity, each with its sizes; nothing when there is no attribute but Size. */
    matrixSummaryContent: function () {
        var matrix = this.model.getQuantityMatrix();
        var quantities = this.matrixQuantities;
        if (matrix.otherNums.length === 0) {
            return '';
        }
        var lines = [];
        matrix.rows.forEach(function (row, index) {
            var sizes = matrix.sizes.map(function (size) {
                var variant = matrix.variantAt(row, size);
                return variant && quantities[variant.id] ? { size: size, quantity: quantities[variant.id] } : null;
            }).filter(Boolean);
            if (sizes.length === 0) {
                return;
            }
            var pieces = sizes.reduce(function (sum, entry) {
                return sum + entry.quantity;
            }, 0);
            lines.push('<li class="c-quantity-grid-summary-row">'
                + '<a class="c-quantity-grid-summary-link" href="javascript:void(0);" onclick="controller.showMatrixRow(' + index + ')">' + strWeb(row) + '</a> '
                + sizes.map(function (entry) {
                    return strWeb(entry.size) + ' ' + entry.quantity;
                }).join(', ') + ' (' + pieces + ')</li>');
        });
        return lines.length === 0 ? ''
            : '<label class="config">Your selections</label><ul class="c-quantity-grid-summary-list">' + lines.join('') + '</ul>';
    },
    setMatrixQuantity: function (variantId, value) {
        var quantity = value === '' ? 0 : Number(value);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > JAVA_INTEGER_MAX_VALUE) {
            growlMessages.showErrorMessage('Quantity must be a whole number.');
            setFieldValue('MATRIXQTY' + variantId, this.matrixQuantities[variantId] || '', document);
            return;
        }
        if (quantity === 0) {
            delete this.matrixQuantities[variantId];
        } else {
            this.matrixQuantities[variantId] = quantity;
        }
        this.refreshMatrixSummary();
        if (this.syncDecorationControls()) {
            this.announceDecoration();
        }
        this.scheduleMatrixQuote();
    },
    refreshMatrixSummary: function () {
        dynamic.setDivIdContent('quantityGridSummary', this.matrixSummaryContent());
        dynamic.setDivIdContent('quantityGridTotal', this.matrixTotalContent());
    },
    matrixEntries: function () {
        var quantities = this.matrixQuantities;
        return this.model.getVariants().filter(function (variant) {
            return quantities[variant.id] > 0;
        }).map(function (variant) {
            return { variant: variant, quantity: quantities[variant.id] };
        });
    },
    matrixTotalContent: function () {
        var entries = this.matrixEntries();
        var pieces = entries.reduce(function (sum, entry) {
            return sum + entry.quantity;
        }, 0);

        if (entries.length === 0) {
            return 'Enter a quantity under each size you want.';
        }
        if (this.isDecoratedGrid()) {
            return pieces + (pieces === 1 ? ' piece' : ' pieces') + ' in ' + this.matrixSpread(entries);
        }

        // Each entry is its own cart line, so "sizes" would miscount one size ordered in two colors.
        return pieces + (pieces === 1 ? ' piece' : ' pieces') + ' across ' + entries.length + (entries.length === 1 ? ' line' : ' lines');
    },

    // TTI-24082: a decorated grid is one decorated order: priced, and held to the minimum, by its total pieces.
    isDecoratedGrid: function () {
        var choice = this.decorationChoice();
        return Boolean(choice && choice.decorations.length > 0);
    },

    matrixPieces: function (entries) {
        return entries.reduce(function (sum, entry) {
            return sum + entry.quantity;
        }, 0);
    },

    // "4 sizes", or "2 colors, 4 sizes" when the pieces are in more than one row of the grid.
    matrixSpread: function (entries) {
        var matrix = this.model.getQuantityMatrix();
        var sizeNum = this.model.getSizeAttributeNumber();
        var count = function (values) {
            return values.filter(function (value, index) {
                return values.indexOf(value) === index;
            }).length;
        };
        var sizes = count(entries.map(function (entry) {
            return entry.variant['attribute' + sizeNum + 'Choice'];
        }));
        var rows = count(entries.map(function (entry) {
            return matrix.otherNums.map(function (num) {
                return entry.variant['attribute' + num + 'Choice'];
            }).join(' / ');
        }));
        var rowNoun = matrix.otherNums.length === 1 ? String(this.model.getStockAttributeTitle(matrix.otherNums[0]) || 'color').toLowerCase() : 'color';
        var sizeText = sizes + (sizes === 1 ? ' size' : ' sizes');
        return rows > 1 ? rows + ' ' + rowNoun + 's, ' + sizeText : sizeText;
    },

    matrixProblem: function () {
        var entries = this.matrixEntries();
        var min = this.model.getStockMinQuantity();
        if (entries.length === 0) {
            return 'Enter a quantity for at least one size.';
        }
        if (this.isDecoratedGrid()) {
            return min && this.matrixPieces(entries) < min ? 'Order at least ' + min + ' pieces in all.' : null;
        }
        var belowMin = entries.filter(function (entry) {
            return min && entry.quantity < min;
        });
        if (belowMin.length > 0) {
            return 'Each size needs at least ' + min + '.';
        }
        return null;
    },
    matrixQuoteRequestId: 0,
    matrixQuoteTimer: null,
    matrixQuoteDelayMs: 300,

    // Tabbing along a row of sizes becomes one round of quotes, sent once the customer stops typing.
    scheduleMatrixQuote: function () {
        this.matrixQuoteRequestId++;
        clearTimeout(this.matrixQuoteTimer);
        this.matrixQuoteTimer = setTimeout(function () {
            controller.quoteMatrix();
        }, this.matrixQuoteDelayMs);
    },

    // The grid's events, documented in docs/theme/quantity-grid-theme-handoff.md; the detail rides a collaterate:* CustomEvent.
    raiseGridEvent: function (constantName, detail) {
        var bus = window.events;
        if (!bus || !bus[constantName]) {
            return;
        }
        bus.trigger(bus[constantName]);
        if (detail !== undefined) {
            document.dispatchEvent(new CustomEvent('collaterate:' + bus[constantName], {
                detail: detail,
                bubbles: true
            }));
        }
    },

    announceMatrixQuote: function (entries, prices, total) {
        this.raiseGridEvent('PRODUCT_QUANTITY_GRID_QUOTED', {
            lines: entries.map(function (entry, index) {
                return { variantId: entry.variant.id, quantity: entry.quantity, price: prices ? prices[index] : null };
            }),
            total: total
        });
    },

    /** Prices each size on its own, as each becomes its own cart line, and shows the total. */
    quoteMatrix: function () {
        var requestId = ++this.matrixQuoteRequestId;
        var entries = this.matrixEntries();
        var problem = this.matrixProblem();
        if (entries.length === 0 || problem) {
            dynamic.setDivIdContent('productQuotePrices', problem && entries.length > 0 ? strWeb(problem) : '--');
            this.announceMatrixQuote(entries, null, entries.length === 0 ? 0 : null);
            return;
        }
        dynamic.setDivIdContent('productQuotePrices', '--');

        var model = this.model;
        var charges = [];
        var groupQuantity = this.isDecoratedGrid() ? this.matrixPieces(entries) : null;
        Promise.all(entries.map(function (entry, index) {
            var data = Object.assign({}, model.generateQuoteRequestData(), {
                quantity: entry.quantity,
                variantId: entry.variant.id
            });
            if (groupQuantity) {
                data.decorationGroupQuantity = groupQuantity;
                data.decorationGroupFirstLine = index === 0;
            }
            data.printJobQuoteSpecOverrides = Object.assign({}, data.printJobQuoteSpecOverrides, {
                variantsChoices: model.getVariantChoicesOf(entry.variant)
            });
            return tbg.apiV2({
                url: controller.getQuoteURL(),
                urlPrefix: '',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                suppressDefaultMessages: true,
                errorHandlers: { default: function () {} }
            }).then(function (response) {
                var content = response && response.content;
                charges[index] = (content && content.decorationCharges) || [];
                return content && content.totalPrice != null ? Number(content.totalPrice) : null;
            }, function () {
                return null;
            });
        })).then(function (prices) {
            if (requestId !== controller.matrixQuoteRequestId) {
                return;
            }
            if (prices.some(function (price) {
                return price == null;
            })) {
                dynamic.setDivIdContent('productQuotePrices', 'Some sizes could not be priced. Your cart will show each price.');
                controller.announceMatrixQuote(entries, prices, null);
                return;
            }
            var total = prices.reduce(function (sum, price) {
                return sum + price;
            }, 0);
            var table = new JDTable({ cssClass: 'quote' });
            table.addRow([
                { text: 'Your Price', tag: 'th', scope: 'row' },
                { text: '<span class="lineItemPrice">$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span>' }
            ], { cssClass: 'productPrice' });
            dynamic.setDivIdContent('productQuotePrices', table.generate() + controller.decorationChargesHtml(controller.sumCharges(charges), {
                total: total,
                pieces: controller.matrixPieces(entries)
            }));
            controller.announceMatrixQuote(entries, prices, total);
        });
    },

    // Each size entered as a cart line of its own.
    matrixItems: function () {
        var model = this.model;
        return this.matrixEntries().map(function (entry) {
            var item = controller.addOrderItemRequestData();

            // The quote engine picks the variant from these choices before the variant id, so each line
            // carries its own; the page's single-variant selection would put every line on one size.
            return Object.assign(item, {
                quantity: entry.quantity,
                productInfoId: controller.getProductInfo({ variantId: entry.variant.id }),
                quoteDataOverrides: Object.assign({}, item.quoteDataOverrides, {
                    variantsChoices: model.getVariantChoicesOf(entry.variant)
                })
            });
        });
    },
    addMatrixToCart: function () {
        var entries = this.matrixEntries();
        var items = this.matrixItems();
        return tbg.apiV2({
            url: '/projects/v2/cart/addItems',
            method: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({ items: items })
        }).then(function (response) {
            var content = (response && response.content) || {};
            var orderItemIds = content.orderItemIds || [];
            controller.raiseGridEvent('PRODUCT_QUANTITY_GRID_ADDED', {
                projectId: content.project ? content.project.id : null,
                lines: entries.map(function (entry, index) {
                    return {
                        variantId: entry.variant.id,
                        quantity: entry.quantity,
                        orderItemId: orderItemIds[index] === undefined ? null : orderItemIds[index]
                    };
                })
            });
            if (hasValue(configuratorGlobals.nextStepUrl)) {
                gotoURL(configuratorGlobals.nextStepUrl);
                return;
            }

            // Nothing navigates away, so clear the grid: a second click would otherwise add every line again.
            growlMessages.showInfoMessage('Added ' + entries.length + (entries.length === 1 ? ' item' : ' items') + ' to your cart.');
            controller.matrixQuantities = {};
            controller.generateQuantityMatrix();
            controller.scheduleMatrixQuote();
        }, function (error) {
            controller.raiseGridEvent('PRODUCT_QUANTITY_GRID_ADD_FAILED');
            throw error;
        });
    },
    gotoNextStep: function () {
        if (hasValue(configuratorGlobals.nextStepUrl)) {
            gotoURL(configuratorGlobals.nextStepUrl);
        }
    },
    generateAvailableInventory: function () {
        var variants = this.model.getVariants();
        var stockAttributeTitle1 = this.model.getStockAttributeTitle(1);
        var stockAttributeTitle2 = this.model.getStockAttributeTitle(2);
        var stockAttributeTitle3 = this.model.getStockAttributeTitle(3);
        var numberOfAttributes = 0;
        var attr1, attr2, attr3;
        if (stockAttributeTitle1) {
            numberOfAttributes++;
            attr1 = stockAttributeTitle1;
        }
        if (stockAttributeTitle2) {
            numberOfAttributes++;
            attr2 = stockAttributeTitle2;
        }
        if (stockAttributeTitle3) {
            numberOfAttributes++;
            attr3 = stockAttributeTitle3;
        }
        content = '';
        if (variants.length > 1) {
            content += '<table id="available-inventory"><tr>';
            for (var i = 0; i < numberOfAttributes; i++) {
                var count = i + 1;
                content += '<th style="text-align: left">' + eval('attr' + count) + '</th>';
            }
            content += '<th style="text-align: left">Inventory</th>';
            content += '</tr>';

            for (var i = 0; i < variants.length; i++) {
                if (variants[i].enabled) {
                    content += '<tr>';
                    for (var a = 0; a < numberOfAttributes; a++) {
                        var count = a + 1;
                        var choice = eval('variants[' + i + '].attribute' + count + 'Choice');
                        content += '<td>' + choice + '</td>';
                    }
                    content += '<td>' + Math.max(this.model.getAvailableInventory(variants[i]), 0) + '</td>';
                    content += '</tr>';
                }
            }
            content += '</table>';
        } else {
            content += 'Available Inventory: <span class="inventory-count">' + Math.max(this.model.getAvailableInventory(variants[0]), 0) + '</span>';
        }
        dynamic.setDivIdContent('availableInventoryQuantity', content);
    },
    updateQuote: function (configChangeDetails) {
        this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });
            configureEvents.onQuoteUpdated(configChangeDetails);
        }.bind(this), function () {
            this.generateUI(configChangeDetails, { list: [] });
        }.bind(this));
    },
    quantityProblem: function (enteredQuantity) {
        var stockMinQuantity = this.model.getStockMinQuantity();

        // Quantity is sent as a JSON number and deserialized into a Java Integer on the server (max 2^31 - 1).
        // If exceeded, the server returns HTTP 400, so we catch it here.
        if (isNaN(enteredQuantity) || enteredQuantity > JAVA_INTEGER_MAX_VALUE) {
            return 'Quantity must be a number.';
        } if (!enteredQuantity || enteredQuantity <= 0) {
            return 'Quantity is required.';
        } if (stockMinQuantity && stockMinQuantity > enteredQuantity) {
            return 'The minimum quantity is ' + stockMinQuantity + '.';
        }
        return '';
    },
    validateQuantity: function (enteredQuantity) {
        var quoteData = configureglobals.cquotedata;
        quoteData.clearFieldErrors('QUANTITYEF');

        var error = this.quantityProblem(enteredQuantity);

        if (error) {
            quoteData.addFieldError('QUANTITYEF', error);
            return false;
        }

        return true;
    }
};

$(function () {
    controller.initialize();
});
